// Function to preserve bundle integrity when adding products
function preserveBundleIntegrity(){
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      if(!data.status && data.items.length > 0){
        const bundleItems = data.items.filter(item =>
          item.properties && item.properties['_bundle'] === 'true'
        );

        if(bundleItems.length > 0){
          // Group bundle items by bundle_id
          const bundles = {};
          bundleItems.forEach(item => {
            const bundleId = item.properties['_bundle_id'];
            if(bundleId){
              if(!bundles[bundleId]){
                bundles[bundleId] = [];
              }
              bundles[bundleId].push(item);
            }
          });

          // Check for duplicate items that exist in bundles but appear as separate line items.
          // IMPORTANT: We only REMOVE duplicates here to avoid fighting bundle remove flows.
          const updates = {};

          data.items.forEach((item) => {
            if (item.properties && item.properties['_bundle'] === 'true') return;

            for(const [bundleId, bundleItemList] of Object.entries(bundles)){
              const matchingBundleItem = bundleItemList.find(bundleItem =>
                bundleItem.product_id === item.product_id &&
                bundleItem.variant_id === item.variant_id
              );

              if(matchingBundleItem){
                updates[item.key] = 0;
                console.log('Removing duplicate item from bundle:', item.product_id, 'bundle_id:', bundleId);
                break;
              }
            }
          });

          // Execute updates if needed
          if(Object.keys(updates).length > 0){
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates })
            })
            .then(response => response.json())
            .then(data => {
              if(!data.status){
                console.log('Bundle integrity preserved - removed duplicates');
                // Update cart icon count
                const countLabel = document.querySelector("#cart-icon-bubble-label");
                if(countLabel) countLabel.innerHTML = data.item_count;

                // Trigger cart update event
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: { product: data }
                }));
              }
            })
            .catch(error => console.error('Error preserving bundle integrity:', error));
          }
        }
      }
    })
    .catch(error => console.error('Error checking bundle integrity:', error));
}

// Run on page load and after cart updates
preserveBundleIntegrity();

function addShippingProtectionOnStart(){
  const shippingOn = localStorage.getItem('shippingProtectionOn');
  const shippingProtectionVariantId = theme.cartInfo.protectionProductVariantId;
  const shippingProtectionId = theme.cartInfo.protectionProductId;
  
  if(!shippingProtectionId || !shippingProtectionVariantId) return;

  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => {
    return response.json();
  }).then(data => {
    if(!data.status){
      if(shippingProtectionId){
        let shippingHas = false;
        data.items.forEach(e=>{
          if(e.product_id == shippingProtectionId){
            shippingHas = true;
          }
        })
        if(!shippingHas){
          if(shippingOn){
            const item = JSON.parse(shippingOn);
            if (Date.now() > item.expiry) {
              addShippingProtectionToCart();
            }
          }else{
            addShippingProtectionToCart();
          }
        }
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  function addShippingProtectionToCart(){
    let formData = {
     'items': [{
      'id': shippingProtectionVariantId,
      'quantity': 1,
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        const localdata = {
          value: 1,
          expiry: Date.now() + 1000 * 60 * 10 // expires in 10 minutes
        };
        localStorage.setItem('shippingProtectionOn', JSON.stringify(localdata));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}
// Initialize shipping protection on page load
document.addEventListener('DOMContentLoaded', function() {
  updateShippingProtection();
});

function updateShippingProtection(){
  const shippingProtectionTrigger = document.querySelector('#cart-shipping-protection-checkbox');
  if(!shippingProtectionTrigger) return;
  
  shippingProtectionTrigger.addEventListener('change',function(){
    const elem = this;
    
    if(this.checked){
      addShippingFromCart(this.dataset.id);
    }else{
      removeItemFromCart(this.dataset.id,0,elem);
    }
  });
  
  function addShippingFromCart(id){
    const checkoutButton = document.querySelector('.cart__checkout-button');
    
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
    }
    
    let formData = {
     'items': [{
      'id': id,
      'quantity': 1,
      }]
    };
    formData['sections_url'] = window.location.pathname;
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        window.location.reload();
      }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
    })
    .catch((error) => {
      elem.checked = false;
      console.error('Error:', error);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
    })
    .finally(() => {
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
    });
  }
}

function freeShipCheck() {
    // Check for free shipping success and trigger confetti
    const hasSuccess = document.querySelector('.free-shipping__progress--success');
    if (hasSuccess) {
      // Get current page load timestamp
      const currentPageLoad = localStorage.getItem('currentPageLoad') || '0';
      const lastConfettiTime = localStorage.getItem('lastFreeShippingConfetti') || '0';
      
      // If this is a new page load (different from last confetti time), show confetti
      if (currentPageLoad !== lastConfettiTime) {
        triggerConfetti();
        localStorage.setItem('lastFreeShippingConfetti', currentPageLoad);
      }
    }
  }

function removeItemFromCart(id,quantity,elem = "",buttonEnable = false){
  const checkoutButton = document.querySelector('.cart__checkout-button');
  
  if(checkoutButton){
    checkoutButton.setAttribute('aria-disabled', true);
    checkoutButton.classList.add('loading');
  }
  
  let formData = JSON.stringify({
    id,
    quantity,
    sections_url: window.location.pathname
  });
  
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: formData
  })
  .then(response => {
     return response.json();
  })
  .then(data=>{
    if(!data.status){
      window.location.reload();
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: data
        }
      }));
    }
  })
  .catch((error) => {
    if(elem){
      elem.checked = true;
    }
    console.error('Error:', error);
    document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
  })
  .finally(() => {
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', false);
      checkoutButton.classList.remove('loading');
    }
  }); 
}

function removeBundleItem(){
  const removeTrigger = document.querySelectorAll('[bundle-item-remove]');
  if(!removeTrigger.length) return;
  const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
  const cart = document.querySelector('form.mini-cart');

  removeTrigger.forEach(e=>{
    e.addEventListener("click",function(){
      const id = this.dataset.id;
      let quantity = 0;
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => {
        return response.json();
      }).then(data => {
        if(!data.status){
          const cartItems = data.items;
          if(cartItems.length > 0){
            cartItems.forEach(e=>{
              if(e.key == id){
                quantity = e.quantity - 1;
              }
            });
            removeItemFromCart(id,quantity,"",true);
          }
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    })
  })
}

function removeGiftItem(){
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
      return response.json();
    }).then(data => {
      if(!data.status){
        const cartItems = data.items;
        let bundleItems = 0;
        let freeGift = false;
        if(cartItems.length > 0){
          cartItems.forEach(e=>{
            const property = e.properties.type;
            if(property){
              if(property == "Feelbar bundle"){
                bundleItems = bundleItems + e.quantity;
              }
              if(property == "Free gift"){
                freeGift = e.key;
              }
            }
          });
          if(bundleItems < 4 && freeGift){
            removeItemFromCart(freeGift,0,"",true);
          }
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function bundleSubscription(){
  const subscriptionToggler = document.querySelector('mini-cart #cart-bundle__selling-plan-bar-input');
  if(subscriptionToggler){
    subscriptionToggler.addEventListener('change',function(){
      if(this.checked){
        this.closest('[bundle-selling-plan]')?.classList.add('active');
      }else{
        this.closest('[bundle-selling-plan]')?.classList.remove('active');
      }
    })
  }
}


let countdownDuration = 6 * 60 + 32; // 6 min 32 sec in seconds
let countdownTimeout;

function getESTHour() {
  const now = new Date();
  const utcOffset = now.getTimezoneOffset(); // in minutes
  const estOffset = 5 * 60; // UTC-5
  const diff = utcOffset - estOffset;
  now.setMinutes(now.getMinutes() + diff);
  return now.getHours();
}

function updateShippingMessages() {
  const estHour = getESTHour();
  const messageEls = document.querySelectorAll("#shipping-message");
  const subtextEls = document.querySelectorAll("#shipping-subtext");

  if (!messageEls.length || !subtextEls.length) return;

  const isSameDay = estHour < 12; // before 12 PM EST
  messageEls.forEach((el) => {
    el.textContent = isSameDay
      ? "Order within the next"
      : "Order in the next";
  });

  subtextEls.forEach((el) => {
    el.textContent = isSameDay
      ? "and it ships today"
      : "and it ships tomorrow!";
  });
}

function updateCountdownDisplays(remainingTime) {
  const countdownEls = document.querySelectorAll("#countdown");
  if (!countdownEls.length) return;

  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;
  const formattedTime =
    minutes + " min : " + (seconds < 10 ? "0" : "") + seconds + " sec";

  countdownEls.forEach((el) => {
    el.textContent = formattedTime;
  });
}

function startSharedCountdown() {
  if (countdownTimeout) clearTimeout(countdownTimeout);

  let startTime = localStorage.getItem("countdownStartTime");
  const now = Date.now();

  if (!startTime) {
    startTime = now;
    localStorage.setItem("countdownStartTime", startTime.toString());
  } else {
    startTime = parseInt(startTime, 10);
  }

  function tick() {
    const elapsed = Math.floor((Date.now() - startTime) / 1000);
    let remainingTime = countdownDuration - elapsed;

    if (remainingTime <= 0) {
      // Timer expired – reset
      countdownDuration = (Math.floor(Math.random() * 3) + 7) * 60; // 7–9 mins
      startTime = Date.now();
      localStorage.setItem("countdownStartTime", startTime.toString());
      updateShippingMessages();
      remainingTime = countdownDuration;
    }

    updateCountdownDisplays(remainingTime);
    countdownTimeout = setTimeout(tick, 1000);
  }

  updateShippingMessages();
  tick();
}

// Initialize timer on page load
// startSharedCountdown(); // Disabled - countdown timer removed from cart drawer

// Only update visuals (don't restart timer)
// ["cart:updated", "cartdrawer:opened", "ajaxProduct:added", "ajaxProduct:error", "discount:added"].forEach(event =>
//   document.addEventListener(event, () => {
//     updateShippingMessages();

//     // Sync display with stored time
//     const startTime = parseInt(localStorage.getItem("countdownStartTime"), 10);
//     const elapsed = Math.floor((Date.now() - startTime) / 1000);
//     const remainingTime = Math.max(countdownDuration - elapsed, 0);
//     updateCountdownDisplays(remainingTime);
//   })
// ); // Disabled - countdown timer removed from cart drawer



['cart:updated', 'cartdrawer:opened', 'ajaxProduct:added', 'ajaxProduct:error', 'discount:added'].forEach(event => document.addEventListener(event, e => {
  updateShippingProtection();
  removeBundleItem();
  removeGiftItem();
  bundleSubscription();
  freeShipCheck();
  updateCartSubscriptionToggle();
  // Preserve bundle integrity ONLY after add events (avoid collisions with bundle removal).
  if (event === 'ajaxProduct:added') {
    setTimeout(() => {
      preserveBundleIntegrity();
    }, 500);
  }
}));

function updateDiscount(){ 
  const discountBar = document.querySelector('.product [discount-bar-block]');
  // if(discountBar){
  //       alert('test');
    // Try both lowercase and capitalized section names for compatibility
    const sectionName = 'discount-bar';
    fetch(window.Shopify.routes.root + "?sections=" + sectionName)
    .then(res => res.json())
    .then(data => {
       // Try both lowercase and capitalized keys
       const sectionData = data[sectionName] || data['Discount-bar'] || data['discount-bar'];
       if (!sectionData) {
         console.warn('Discount bar section not found in response');
         return;
       }
       const html = new DOMParser().parseFromString(sectionData, 'text/html');
      if(discountBar){
       const discountBarBlock = html.querySelector('[discount-bar-block]');
       if (discountBarBlock) {
         discountBar.innerHTML = discountBarBlock.innerHTML;
       }
      }
       const newDiscountBar = html.querySelector('[discount-bar-block]');

        if (newDiscountBar) {
          const milestoneEls = newDiscountBar.querySelectorAll('.discount-bar__milestone');
          const reachedMilestones = [];

          milestoneEls.forEach((milestoneEl) => {
            const milestoneValue = milestoneEl.getAttribute('data-milestone');
            const isActive = milestoneEl.classList.contains('active');
            const milestoneKey = 'confetti_milestone_' + milestoneValue;
            const currentPageLoad = localStorage.getItem('currentPageLoad') || Date.now().toString();

            if (isActive) {
              reachedMilestones.push(milestoneKey);
              // Get the last time confetti was shown for this milestone
              const lastConfettiTime = localStorage.getItem(milestoneKey + '_time') || '0';

              // Show confetti if this is a new page load or milestone was just reached
              if (currentPageLoad !== lastConfettiTime) {
                // Trigger confetti for each newly reached milestone
                triggerConfetti();
                localStorage.setItem(milestoneKey + '_time', currentPageLoad);
              }
            }
          });
        }
       
    })
    .catch((error) => {
      console.error('Error updating discount bar:', error);
    });
  // }

  // Also check milestones in cart drawer (mini-cart)
  // The cart drawer uses different classes: .milestone--text with .active class
  // Use a small delay to ensure cart drawer DOM is fully rendered
  checkCartMilestones();
}

function checkCartMilestones() {
  setTimeout(function() {
    const cartDrawer = document.querySelector('mini-cart');
    if (cartDrawer) {
      const cartMilestones = cartDrawer.querySelectorAll('.milestone--text.active');
      const currentPageLoad = localStorage.getItem('currentPageLoad') || Date.now().toString();
      
      cartMilestones.forEach((milestoneEl, index) => {
        // Create a unique key for each milestone based on its index and text
        const milestoneText = milestoneEl.textContent.trim();
        const milestoneKey = 'confetti_cart_milestone_' + index + '_' + milestoneText.substring(0, 20).replace(/\s+/g, '_');
        
        // Get the last time confetti was shown for this milestone
        const lastConfettiTime = localStorage.getItem(milestoneKey + '_time') || '0';
        
        // Show confetti if:
        // 1. This is a new page load (milestone wasn't shown for this page load yet)
        // 2. OR this milestone was just reached (different from last time)
        if (currentPageLoad !== lastConfettiTime) {
          // Trigger confetti for each reached milestone in cart
          triggerConfetti();
          localStorage.setItem(milestoneKey + '_time', currentPageLoad);
        }
      });
    }
  }, 100);
}

// Update shipping text display
function updateShippingTextDisplay() {
  if (document.querySelector('.mini-cart__inner .free-shipping__text--success')) {
    const shippingTextEl = document.querySelector('.shipping-text-success');
    if (shippingTextEl) {
      shippingTextEl.innerText = "FREE Shipping";
    }
  } else {
    const shippingTextEl = document.querySelector('.shipping-text-success');
    if (shippingTextEl) {
      shippingTextEl.innerText = "Calculated at checkout";
    }
  }
}

function triggerConfetti() {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 }
  });
}



// Function to handle adding products to cart with proper defaults
function handleProductAddToCart() {
  // Override the default add to cart behavior to ensure one-time purchase for single products
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;

    // Intercept cart/add.js calls
    if (url && url.includes && url.includes('/cart/add.js') && options && options.method === 'POST') {
      try {
        const body = JSON.parse(options.body);

        // Check if this is a bundle addition (has bundle properties) or single product
        const isBundleAddition = body.items && Array.isArray(body.items) &&
          body.items.some(item => item.properties && item.properties['_bundle'] === 'true');

        // If adding single products (not bundle) and no selling_plan is specified,
        // ensure it's set to null for one-time purchase
        if (body.items && Array.isArray(body.items) && !isBundleAddition) {
          body.items.forEach(item => {
            // Only set selling_plan to null if it's not already specified
            // This preserves any subscription selection made by the user
            if (item.selling_plan === undefined) {
              item.selling_plan = null;
              console.log('Setting default one-time purchase for single product:', item.id);
            }
          });
        }

        // Update the request body
        options.body = JSON.stringify(body);
      } catch (error) {
        console.warn('Error intercepting cart add request:', error);
      }
    }

    return originalFetch.apply(this, args);
  };
}

// Function to check and update cart subscription toggle based on cart contents
function updateCartSubscriptionToggle() {
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(data => {
      if (!data.status && data.items && data.items.length > 0) {
        // Check if any item in cart has one-time purchase (no selling_plan_allocation)
        const hasOneTimePurchase = data.items.some(item =>
          !item.selling_plan_allocation || item.selling_plan_allocation.selling_plan === null
        );

        // Find the cart subscription toggle
        const cartSubscriptionInput = document.querySelector('#mini-cart-subscription-input');
        if (cartSubscriptionInput) {
          // If any item has one-time purchase, uncheck the cart subscription toggle
          if (hasOneTimePurchase && cartSubscriptionInput.checked) {
            cartSubscriptionInput.checked = false;
            console.log('Unchecked cart subscription toggle due to one-time purchase items');
          }
        }
      }
    })
    .catch(error => console.error('Error checking cart subscription status:', error));
}

// Function to show centered cart loader
function showCartLoader() {
  // Remove any existing loader
  hideCartLoader();

  const cart = document.querySelector('form.mini-cart');
  if (!cart) return;

  const loader = document.createElement('div');
  loader.className = 'cart-subscription-loader';
  loader.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    backdrop-filter: blur(2px);
  `;

  const loaderContent = document.createElement('div');
  loaderContent.style.cssText = `
    text-align: center;
    color: #333;
    padding: 20px;
    border-radius: 12px;
    background: white;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  `;

  const spinner = document.createElement('div');
  spinner.style.cssText = `
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #333;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
  `;

  // Add spinner animation if not already in document
  if (!document.getElementById('cart-loader-spinner-style')) {
    const style = document.createElement('style');
    style.id = 'cart-loader-spinner-style';
    style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
    document.head.appendChild(style);
  }

  const loadingText = document.createElement('div');
  loadingText.textContent = 'Updating subscription...';
  loadingText.style.cssText = 'font-size: 16px; font-weight: 500; color: #333;';

  loaderContent.appendChild(spinner);
  loaderContent.appendChild(loadingText);
  loader.appendChild(loaderContent);

  // Add to cart element
  cart.appendChild(loader);

  // Disable scroll
  document.body.style.overflow = 'hidden';
}

// Function to hide cart loader
function hideCartLoader() {
  const existingLoader = document.querySelector('.cart-subscription-loader');
  if (existingLoader) {
    existingLoader.remove();
  }
  document.body.style.overflow = '';
}

// Initialize on page load
handleProductAddToCart();
updateCartSubscriptionToggle();

// Set page load timestamp on page load - this ensures confetti shows on each page reload
if (typeof localStorage !== 'undefined') {
  localStorage.setItem('currentPageLoad', Date.now().toString());
}

// Check milestones when cart drawer opens (after page reload or when opened)
function checkMilestonesOnCartOpen() {
  // Check both discount bar milestones and cart drawer milestones
  updateDiscount();
  checkCartMilestones();
  freeShipCheck();
  updateShippingTextDisplay();
}

document.addEventListener('ajaxProduct:added',updateDiscount);
document.addEventListener('cart:updated',updateDiscount);
document.addEventListener('cartdrawer:opened',checkMilestonesOnCartOpen);

// Also check on initial page load when cart might already be open
document.addEventListener('DOMContentLoaded', function() {
  // Small delay to ensure cart drawer is rendered
  setTimeout(checkMilestonesOnCartOpen, 500);
});

function updateShippingText() {
    setTimeout(function() {
        const successText = document.querySelector('.mini-cart__inner .free-shipping__text--success');
        const shippingText = document.querySelector('.shipping-text-success');
        if (shippingText) {
            shippingText.innerText = successText ? "FREE Shipping" : "Calculated at checkout";
        }
    }, 3000);
}

document.addEventListener('DOMContentLoaded', updateShippingText);
window.addEventListener('load', updateShippingText);

  window.addEventListener('scroll', function() {
    const header = document.querySelector('sticky-header');
    const scrollY = window.scrollY;

    if (scrollY > 10) {
      header.classList.add('scrolleddd');
    } else {
      header.classList.remove('scrolleddd');
    }
  });
  
class cartSubscription extends HTMLElement {
  constructor() {
    super();
    this._isUpdating = false;
  }

  connectedCallback() {
    this.cart = document.querySelector('mini-cart');
    this.checkoutButton = this.cart?.querySelector('button[name="checkout"]');
    if(!this.cart || !this.checkoutButton) return;

    this.selectBar = this.querySelector('#mini-cart-subscription-input');
    if(this.selectBar){
      const parent = this;
      this.selectBar.addEventListener('change', function(){
        if(parent._isUpdating) return; // Prevent recursive calls

        if(this.checked){
          parent.changeSubscription(true);
        }else{
          parent.changeSubscription(false);
        }
      })
    }

    // Listen for subscription updates to update the global checkbox
    document.addEventListener('subscription-updated', () => {
      this.updateGlobalCheckboxState();
    });

    // Update checkbox state on cart changes
    document.addEventListener('cart:updated', () => {
      this.updateGlobalCheckboxState();
    });
  }

  updateGlobalCheckboxState() {
    if(this._isUpdating) return;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {
        if(!data.status && data.items.length > 0){
          // Check if any non-bundle, non-special items have subscriptions
          let hasAnySubscriptions = false;
          let hasAnyOneTimePurchases = false;

          data.items.forEach(item => {
            // Skip bundle items, shipping protection, free gifts, etc.
            const isSpecialItem = (
              item.properties?.type === 'shipping-protection' ||
              item.properties?.type === 'Free gift' ||
              item.product.tags?.includes('shipping-protection') ||
              item.product.tags?.includes('free-gift') ||
              (item.properties && item.properties['_bundle'] === 'true')
            );

            if(!isSpecialItem && item.product.selling_plan_groups?.size > 0){
              if(item.selling_plan_allocation){
                hasAnySubscriptions = true;
              }else{
                hasAnyOneTimePurchases = true;
              }
            }
          });

          // Update checkbox: checked only if all eligible items have subscriptions
          const shouldBeChecked = hasAnySubscriptions && !hasAnyOneTimePurchases;

          if(this.selectBar && this.selectBar.checked !== shouldBeChecked){
            this._isUpdating = true;
            this.selectBar.checked = shouldBeChecked;
            this._isUpdating = false;
          }
        }
      })
      .catch(error => console.error('Error updating global checkbox state:', error));
  }

  async handleSubscription(key, quantity, selling_plan, isLastAction) {
    try {
      const cart = document.querySelector('form.mini-cart');
      const checkoutButton = cart.querySelector('button[name="checkout"]');
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', true);
        checkoutButton.classList.add('loading');
      }
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity,
          selling_plan,
          // If a mini-cart element exists, request updated sections so totals/prices refresh
          sections: document.querySelector('mini-cart')?.getSectionsToRender?.().map((s) => s.section).filter(Boolean) || [],
          sections_url: window.location.pathname
        })
      });

      const state = await response.json();
      if(isLastAction) {
        if(checkoutButton){
          checkoutButton.setAttribute('aria-disabled', false);
          checkoutButton.classList.remove('loading');
          // Update checkout button pricing after loading is removed
          setTimeout(() => {
            updateCheckoutButtonPricing();
          }, 100);
        }
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response
            }
          }));
        },1000)
      }
      
    } catch (error) {
      console.error('Error updating cart:', error);
      const cart = document.querySelector('form.mini-cart');
      const checkoutButton = cart.querySelector('button[name="checkout"]');
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }
  }

  showCartLoader() {
    if(this.cartLoader) return; // Already showing

    this.cartLoader = document.createElement('div');
    this.cartLoader.className = 'cart-subscription-loader';
    this.cartLoader.innerHTML = `
      <div class="cart-loader-overlay">
        <div class="cart-loader-content">
          <div class="cart-spinner"></div>
          <div class="cart-loader-text">Updating subscription...</div>
        </div>
      </div>
    `;

    // Add styles
    if(!document.getElementById('cart-loader-styles')) {
      const style = document.createElement('style');
      style.id = 'cart-loader-styles';
      style.textContent = `
        .cart-subscription-loader {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 10000;
          pointer-events: none;
        }
        .cart-loader-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(2px);
        }
        .cart-loader-content {
          text-align: center;
          color: #333;
        }
        .cart-spinner {
          width: 50px;
          height: 50px;
          border: 4px solid #f3f3f3;
          border-top: 4px solid #333;
          border-radius: 50%;
          animation: cartSpin 1s linear infinite;
          margin: 0 auto 16px;
        }
        .cart-loader-text {
          font-size: 16px;
          font-weight: 500;
        }
        @keyframes cartSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }

    document.body.appendChild(this.cartLoader);
  }

  hideCartLoader() {
    if(this.cartLoader) {
      this.cartLoader.remove();
      this.cartLoader = null;
    }
  }

  async changeSubscription(enableSelling = false){
    // Show centered cart loader
    showCartLoader();

    const cart = document.querySelector('form.mini-cart');
    const lineItems = Array.from(cart.querySelectorAll('cart-items [data-cart-line-item]'));
    if(!lineItems.length) {
      hideCartLoader();
      return;
    }

    let hasErrors = false;

    try {
      // Separate bundle items from single items
      const bundleItems = lineItems.filter(item => item.dataset.bundleId);
      const singleItems = lineItems.filter(item => !item.dataset.bundleId);

      // Handle bundle items first (they need special subscription logic)
      if (bundleItems.length > 0) {
        for (let i = 0; i < bundleItems.length; i++) {
          const bundleItem = bundleItems[i];
          const bundleSelector = document.querySelector(`subscription-selector[data-bundle-id="${bundleItem.dataset.bundleId}"][data-bundle-mode="true"]`);

          if (bundleSelector) {
            // Use the bundle selector's changeBundleSubscription method
            await new Promise((resolve) => {
              bundleSelector.changeBundleSubscription(bundleItem.dataset.bundleId, enableSelling ? bundleItem.dataset.itemPlan : null);
              // Wait for bundle update to complete
              setTimeout(resolve, 100);
            });
          }
        }
      }

      // Handle single items
      for (let i = 0; i < singleItems.length; i++) {
        const line = singleItems[i];
        const isLast = i === singleItems.length - 1 && bundleItems.length === 0;
        const result = await this.handleSubscription(
          line.dataset.cartLineItem,
          Number(line.dataset.quantity),
          enableSelling ? Number(line.dataset.itemPlan) : null,
          isLast
        );

        if(result && result.error) {
          hasErrors = true;
        }
      }
    } catch(error) {
      console.error('Error in changeSubscription:', error);
      hasErrors = true;
    }

    // Update cart subscription toggle status after changes
    updateCartSubscriptionToggle();

    // Hide loader after a short delay to ensure UI updates are complete
    setTimeout(() => {
      hideCartLoader();
    }, 500);
  }
}

customElements.define("cart-subscription", cartSubscription);


class SubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this._isUpdatingUI = false; // Flag to prevent recursive calls
    this._updateTimeout = null; // Debounce timeout
    this._lastChangeTime = 0; // Track last change to prevent rapid calls
  }

  connectedCallback() {
    console.log('SubscriptionSelector: connectedCallback called', {
      dataset: {
        bundleMode: this.dataset.bundleMode,
        bundleId: this.dataset.bundleId,
        itemKey: this.dataset.itemKey,
        itemQuantity: this.dataset.itemQuantity
      },
      innerHTML: this.innerHTML.substring(0, 200) + '...' // First 200 chars for debugging
    });

    this.isBundleMode = this.dataset.bundleMode === 'true';
    this.bundleId = this.dataset.bundleId;
    this.itemKey = this.dataset.itemKey;
    this.itemQuantity = this.dataset.itemQuantity;

    console.log('SubscriptionSelector: parsed properties', {
      isBundleMode: this.isBundleMode,
      bundleId: this.bundleId,
      itemKey: this.itemKey,
      itemQuantity: this.itemQuantity
    });

    // Get collapsed and expanded views
    this.collapsedView = this.querySelector('.subscription-collapsed-view');
    this.expandedView = this.querySelector('.subscription-expanded-view');
    this.planNameDisplay = this.querySelector('.subscription-plan-name');
    this.editButton = this.querySelector('.subscription-edit-btn');
    this.closeButton = this.querySelector('.subscription-close-btn');

    // Set up Edit button
    if (this.editButton) {
      this.editButton.addEventListener('click', () => {
        this.expandView();
      });
    }

    // Set up Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.collapseView();
      });
    }

    // Get all radio buttons
    this.radioButtons = this.querySelectorAll('input[type="radio"]');
    console.log('SubscriptionSelector: found radio buttons', this.radioButtons.length);

    // Listen for radio button changes
    this.radioButtons.forEach((radio, index) => {
      console.log('SubscriptionSelector: attaching listener to radio', index, {
        value: radio.value,
        checked: radio.checked,
        name: radio.name
      });
      radio.addEventListener('change', (e) => {
        // Only handle if this is a user-initiated change (not programmatic)
        if (e.target.checked && !this._isUpdatingUI) {
          // Debounce rapid changes
          const now = Date.now();
          if (now - this._lastChangeTime < 500) {
            console.log('SubscriptionSelector: Debouncing rapid change');
            return;
          }
          this._lastChangeTime = now;
          this.handleRadioChange(e.target);
        }
      });
    });

    // Initialize collapsed view with current selection
    this.updateCollapsedView();
  }

  expandView() {
    if (this.collapsedView) {
      this.collapsedView.style.display = 'none';
    }
    if (this.expandedView) {
      this.expandedView.style.display = 'block';
    }
  }

  collapseView() {
    if (this.collapsedView) {
      this.collapsedView.style.display = 'flex';
    }
    if (this.expandedView) {
      this.expandedView.style.display = 'none';
    }
    // Update the collapsed view to reflect any changes
    this.updateCollapsedView();
  }

  updateCollapsedView() {
    if (!this.planNameDisplay) return;
    
    // Find the checked radio button
    const checkedRadio = this.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      const radioLabel = checkedRadio.closest('.subscription-radio-option');
      if (radioLabel) {
        const labelText = radioLabel.querySelector('.radio-label');
        if (labelText) {
          this.planNameDisplay.textContent = labelText.textContent.trim();
        }
      }
    }
  }

  scheduleCollapseAfterRender() {
    // Wait for cart to re-render, then find and collapse the subscription selector
    // The element might be recreated during cart re-render, so we need to find it again
    const findAndCollapse = () => {
      let selector = null;
      if (this.isBundleMode && this.bundleId) {
        selector = document.querySelector(`subscription-selector[data-bundle-id="${this.bundleId}"][data-bundle-mode="true"]`);
      } else if (this.itemKey) {
        selector = document.querySelector(`subscription-selector[data-item-key="${this.itemKey}"]`);
      }
      
      if (selector) {
        // Update collapsed view and collapse
        if (selector.updateCollapsedView) {
          selector.updateCollapsedView();
        }
        if (selector.collapseView) {
          selector.collapseView();
        }
      } else {
        // If not found, try again after a short delay
        setTimeout(findAndCollapse, 100);
      }
    };
    
    // Try immediately
    setTimeout(findAndCollapse, 300);
    
    // Also listen for cart render completion
    const cartRenderHandler = () => {
      setTimeout(findAndCollapse, 100);
      document.removeEventListener('ajaxProduct:added', cartRenderHandler);
    };
    document.addEventListener('ajaxProduct:added', cartRenderHandler);
  }

  handleRadioChange(radio) {
    const sellingPlan = radio.value || '';
    const planName = radio.dataset.planName || ''; // Get plan name for Recharge matching

    console.log('SubscriptionSelector: handleRadioChange called', {
      radioValue: radio.value,
      sellingPlan: sellingPlan,
      planName: planName,
      isBundleMode: this.isBundleMode,
      bundleId: this.bundleId,
      itemKey: this.itemKey,
      itemQuantity: this.itemQuantity,
      radioData: {
        option: radio.dataset.option,
        itemQuantity: radio.dataset.itemQuantity,
        bundleId: radio.dataset.bundleId,
        planName: planName
      },
      currentCheckedState: radio.checked
    });

    if (this.isBundleMode && this.bundleId) {
      // Handle bundle subscription change
      // For Recharge: Use plan name to find matching plan ID for each product
      console.log('SubscriptionSelector: handling bundle mode');
      this.changeBundleSubscription(this.bundleId, sellingPlan, planName);
    } else {
      // Handle single item subscription change
      console.log('SubscriptionSelector: handling individual item mode');
      const itemKey = this.itemKey || radio.dataset.option;
      const quantity = this.itemQuantity || radio.dataset.itemQuantity;
      this.changeCartItem(itemKey, quantity, sellingPlan);
    }

    // Note: We don't dispatch the change event here anymore since updateSelectedRadioButton handles it
    // This prevents duplicate events
  }

  showLoader() {
    // Use global cart loader for consistency
    showCartLoader();

    // Disable radio buttons during update
    const radioButtons = this.querySelectorAll('input[type="radio"]');
    radioButtons.forEach(radio => {
      radio.disabled = true;
      radio.style.pointerEvents = 'none';
    });
  }

  hideLoader() {
    // Use global cart loader for consistency
    hideCartLoader();

    // Re-enable radio buttons
    const radioButtons = this.querySelectorAll('input[type="radio"]');
    radioButtons.forEach(radio => {
      radio.disabled = false;
      radio.style.pointerEvents = '';
    });
  }

  async changeBundleSubscription(bundleId, sellingPlan, planName = '') {
    // Debounce rapid calls - reduced for faster response
    if (this._updateTimeout) {
      clearTimeout(this._updateTimeout);
    }

    this._updateTimeout = setTimeout(async () => {
      await this._executeBundleSubscriptionChange(bundleId, sellingPlan, planName);
    }, 100);
  }

  async _executeBundleSubscriptionChange(bundleId, sellingPlan, planName = '') {
    // Show loader
    this.showLoader();

    // Performance timing - start tracking
    const performanceTiming = {
      startTime: performance.now(),
      steps: {},
      itemUpdateTimes: []
    };

    console.log('SubscriptionSelector: changeBundleSubscription called', {
      bundleId: bundleId,
      sellingPlan: sellingPlan,
      sellingPlanType: typeof sellingPlan
    });

    const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
    const cart = document.querySelector('form.mini-cart');

    // Find the subscription selector element for this bundle
    const subscriptionSelector = document.querySelector(`cart-subscription[data-bundle-id="${bundleId}"]`);
    let loadingOverlay = null;
    
    // Create and show loading overlay to prevent UI flickering
    if (subscriptionSelector) {
      // Create loading overlay
      loadingOverlay = document.createElement('div');
      loadingOverlay.className = 'subscription-selector-loading';
      loadingOverlay.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        border-radius: 8px;
      `;
      
      const loadingContent = document.createElement('div');
      loadingContent.style.cssText = `
        text-align: center;
        color: #333;
      `;
      
      const spinner = document.createElement('div');
      spinner.style.cssText = `
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #333;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 10px;
      `;
      
      // Add spinner animation if not already in document
      if (!document.getElementById('subscription-spinner-style')) {
        const style = document.createElement('style');
        style.id = 'subscription-spinner-style';
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);
      }
      
      const loadingText = document.createElement('div');
      loadingText.textContent = 'Updating subscription...';
      loadingText.style.cssText = 'font-size: 14px; font-weight: 500;';
      
      loadingContent.appendChild(spinner);
      loadingContent.appendChild(loadingText);
      loadingOverlay.appendChild(loadingContent);
      
      // Make selector position relative if not already
      const selectorStyle = window.getComputedStyle(subscriptionSelector);
      if (selectorStyle.position === 'static') {
        subscriptionSelector.style.position = 'relative';
      }
      
      // Disable all radio buttons during update
      const radioButtons = subscriptionSelector.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(radio => {
        radio.disabled = true;
        radio.style.pointerEvents = 'none';
      });
      
      // Add loading overlay
      subscriptionSelector.appendChild(loadingOverlay);
    }
    
    if (checkoutButton) {
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
      // Store original HTML and show loading state
      if (!checkoutButton.dataset.originalHTML) {
        checkoutButton.dataset.originalHTML = checkoutButton.innerHTML;
      }
      checkoutButton.textContent = 'Updating...';
    }
    
    // Set flag to prevent UI updates during bundle update
    this._isUpdatingBundle = true;

    try {
      // Get current cart to find all bundle items
      console.log('SubscriptionSelector: fetching current cart data');
      const cartFetchStart = performance.now();
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();
      performanceTiming.steps.initialCartFetch = performance.now() - cartFetchStart;
      console.log('SubscriptionSelector: ⏱️ Initial cart fetch took', performanceTiming.steps.initialCartFetch.toFixed(2), 'ms');

      console.log('SubscriptionSelector: cart data received', {
        cartStatus: cartData.status,
        itemCount: cartData.items ? cartData.items.length : 0,
        items: cartData.items ? cartData.items.map(item => ({
          key: item.key,
          title: item.title,
          properties: item.properties
        })) : []
      });

      if (cartData.status) {
        throw new Error('Failed to get cart');
      }

      // Find all items in this bundle
      const bundleItems = cartData.items.filter(item =>
        item.properties &&
        item.properties['_bundle'] === 'true' &&
        item.properties['_bundle_id'] === bundleId
      );

      console.log('SubscriptionSelector: bundle items found', {
        bundleId: bundleId,
        bundleItemsCount: bundleItems.length,
        bundleItems: bundleItems.map(item => ({
          key: item.key,
          title: item.title,
          bundle_id: item.properties['_bundle_id']
        }))
      });

      // If no bundle items found, the bundle may have been split into individual items
      // This can happen when subscription changes cause cart re-renders
      if (bundleItems.length === 0) {
        console.warn('SubscriptionSelector: No bundle items found - bundle may have been split or removed');
        this.showError('Bundle items not found. The cart may have been updated. Please refresh the page.');
        return;
      }

      // Log detailed item information for debugging
      console.log('SubscriptionSelector: detailed bundle items data', {
        bundleItems: bundleItems.map(item => ({
          key: item.key,
          title: item.title,
          variant_id: item.variant_id,
          product_id: item.product_id,
          selling_plan_allocation: item.selling_plan_allocation,
          has_variant_data: !!item.variant,
          variant_keys: item.variant ? Object.keys(item.variant) : [],
          has_variant_selling_plan_allocations: !!(item.variant?.selling_plan_allocations),
          variant_selling_plan_allocations_count: item.variant?.selling_plan_allocations?.length || 0,
          url: item.url || 'no url',
          handle_from_url: item.url ? (item.url.match(/\/products\/([^?]+)/)?.[1] || 'no match') : 'no url'
        }))
      });

      // CRITICAL: For Recharge, different products have different plan IDs for the same plan name
      // We need to match by plan NAME and find each product's matching plan ID
      // If planName is provided, we'll fetch product data to find matching plan IDs
      console.log('SubscriptionSelector: attempting to update all bundle items', {
        totalItems: bundleItems.length,
        sellingPlan: sellingPlan,
        planName: planName,
        usePlanNameMatching: !!planName && !!sellingPlan
      });

      // SEQUENTIAL updates to avoid rate limiting (429 errors)
      // Appstle interceptor multiplies requests, so we must go one at a time
      // CRITICAL: Shopify requires using 'line' (1-based index) instead of 'id' when updating selling_plan
      // IMPORTANT: After each update, cart items change (keys, line indices), so we need to fetch cart again
      const results = [];
      let currentCartData = cartData; // Start with initial cart data
      
      // If we have plan name, fetch product data to get matching plan IDs for each product
      // CRITICAL for Recharge: Each product has different plan IDs for the same plan name
      let productPlanMap = {}; // Maps product_id -> plan_id for the selected plan name
      let selectedPlanIndex = -1; // Index of the selected plan in the plan list (for position-based fallback)
      // CRITICAL: Declare targetGroupId at function scope so it's accessible in both the product mapping block
      // and the item update loop (which has a separate if (planName && sellingPlan) block)
      let targetGroupId = null;
      if (planName && sellingPlan) {
        console.log('SubscriptionSelector: Fetching product data to match plan names for Recharge compatibility');
        try {
          // Get product handles from DOM (cart drawer already has them in data-handle attributes)
          // Or fetch from cart items if variant has selling_plan_allocations
          const uniqueProducts = {};
          bundleItems.forEach(item => {
            if (!uniqueProducts[item.product_id]) {
              uniqueProducts[item.product_id] = {
                product_id: item.product_id,
                variant_id: item.variant_id,
                variant: item.variant,
                // Cart items should have variant with selling_plan_allocations
                selling_plan_allocations: item.variant?.selling_plan_allocations || []
              };
            }
          });
          
          // Check if cart items have selling plan allocations in variant data
          // This is MUCH better than fetching product JSON - cart data has full selling plan objects!
          console.log('SubscriptionSelector: DEBUG - Checking cart item variant data for selling plans', {
            firstItem: bundleItems[0] ? {
              product_id: bundleItems[0].product_id,
              variant_id: bundleItems[0].variant_id,
              hasVariant: !!bundleItems[0].variant,
              hasSellingPlanAllocations: !!(bundleItems[0].variant?.selling_plan_allocations),
              allocationsCount: bundleItems[0].variant?.selling_plan_allocations?.length || 0,
              firstAllocation: bundleItems[0].variant?.selling_plan_allocations?.[0],
              firstAllocationHasSellingPlan: !!(bundleItems[0].variant?.selling_plan_allocations?.[0]?.selling_plan),
              firstAllocationSellingPlanName: bundleItems[0].variant?.selling_plan_allocations?.[0]?.selling_plan?.name
            } : null
          });
          
          // Try to use cart variant data FIRST (no API calls needed!)
          // Find the selected plan's group_id from ANY product that has cart variant data
          // This is critical: if the first product doesn't have allocations, try others
          // Note: targetGroupId is now declared at function scope above
          
          // First pass: Find targetGroupId from any product that has the selected plan
          // Try matching by plan ID first, then by plan name if ID doesn't match
          for (const productInfo of Object.values(uniqueProducts)) {
            if (targetGroupId) break; // Already found, no need to continue
            
            const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
            if (cartItem?.variant?.selling_plan_allocations && sellingPlan) {
              const allocations = cartItem.variant.selling_plan_allocations;
              
              // Find the selected plan's group_id
              // First try: Match by plan ID
                for (const allocation of allocations) {
                  // Check if allocation has selling_plan_id (product JSON format) or selling_plan.id (cart format)
                  const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                  if (planId && String(planId) === String(sellingPlan)) {
                    targetGroupId = allocation.selling_plan_group_id;
                    productPlanMap[productInfo.product_id] = planId;
                  console.log('SubscriptionSelector: ✅ Found target group_id from cart variant data (by ID)!', {
                      productId: productInfo.product_id,
                    productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                      selectedPlanId: sellingPlan,
                      groupId: targetGroupId,
                      planId: planId
                    });
                    break;
                  }
              }
              
              // Second try: If ID matching failed and we have planName, try matching by plan name
              if (!targetGroupId && planName) {
                const normalizedPlanName = planName.trim().toLowerCase();
                for (const allocation of allocations) {
                  const planNameToCheck = allocation.selling_plan?.name;
                  if (planNameToCheck) {
                    const normalizedAllocationName = planNameToCheck.trim().toLowerCase();
                    if (normalizedAllocationName === normalizedPlanName || 
                        normalizedAllocationName.includes(normalizedPlanName) ||
                        normalizedPlanName.includes(normalizedAllocationName)) {
                      targetGroupId = allocation.selling_plan_group_id;
                      const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                      if (planId) {
                        productPlanMap[productInfo.product_id] = planId;
                        console.log('SubscriptionSelector: ✅ Found target group_id from cart variant data (by name)!', {
                          productId: productInfo.product_id,
                          productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                          selectedPlanId: sellingPlan,
                          planName: planName,
                          matchedPlanName: planNameToCheck,
                          groupId: targetGroupId,
                          planId: planId
                        });
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
          
          // Second pass: If we found targetGroupId, match ALL products by group_id
          if (targetGroupId) {
            for (const productInfo of Object.values(uniqueProducts)) {
              // Skip if already mapped
              if (productPlanMap[productInfo.product_id]) continue;
              
              const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
              if (cartItem?.variant?.selling_plan_allocations) {
                const allocations = cartItem.variant.selling_plan_allocations;
                for (const allocation of allocations) {
                  if (allocation.selling_plan_group_id === targetGroupId) {
                    const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                    if (planId) {
                      productPlanMap[productInfo.product_id] = planId;
                      console.log('SubscriptionSelector: ✅ Matched plan by group_id from cart data!', {
                        productId: productInfo.product_id,
                        productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                        groupId: targetGroupId,
                        planId: planId
                      });
                      break;
                    }
                  }
                }
              }
            }
          }
          
          // If we found plans using cart data, skip product JSON fetching
          if (Object.keys(productPlanMap).length > 0) {
            console.log('SubscriptionSelector: Successfully mapped plans using cart variant data', {
              mappedProducts: Object.keys(productPlanMap).length,
              totalProducts: Object.keys(uniqueProducts).length,
              targetGroupId: targetGroupId
            });
          }
          
          // Try to get product handles from DOM first (faster, no API calls)
          // Cart drawer has data-handle attributes on list items
          console.log('SubscriptionSelector: DEBUG - Starting product handle lookup', {
            bundleItemsCount: bundleItems.length,
            uniqueProductsCount: Object.keys(uniqueProducts).length,
            planName: planName
          });
          
          // Try multiple selectors, prioritizing form elements (not style tags)
          // Exclude style tags explicitly
          let cartDrawer = null;
          const possibleSelectors = [
            'form#cart.mini-cart',
            'form.mini-cart',
            '#cart.mini-cart',
            '.mini-cart',
            '#CartDrawer',
            '.cart-drawer'
          ];
          
          for (const selector of possibleSelectors) {
            const element = document.querySelector(selector);
            if (element && element.tagName !== 'STYLE' && element.tagName !== 'SCRIPT') {
              cartDrawer = element;
              break;
            }
          }
          
          console.log('SubscriptionSelector: DEBUG - Cart drawer element', {
            found: !!cartDrawer,
            element: cartDrawer ? cartDrawer.tagName : null,
            id: cartDrawer ? cartDrawer.id : null,
            className: cartDrawer ? cartDrawer.className : null,
            isForm: cartDrawer ? cartDrawer.tagName === 'FORM' : false
          });
          
          const productHandleMap = {};
          if (cartDrawer && cartDrawer.tagName !== 'STYLE') {
            // Try multiple selectors to find cart items - be more comprehensive
            const allCartItems = cartDrawer.querySelectorAll('li[data-variant-id], [data-variant-id], [data-product-id], .cart-item, .line-item');
            console.log('SubscriptionSelector: DEBUG - Found cart items in DOM', {
              totalItems: allCartItems.length,
              items: Array.from(allCartItems).slice(0, 10).map(el => ({
                variantId: el.getAttribute('data-variant-id'),
                productId: el.getAttribute('data-product-id'),
                handle: el.getAttribute('data-handle') || el.dataset.handle,
                hasHandle: !!(el.getAttribute('data-handle') || el.dataset.handle),
                tagName: el.tagName,
                className: el.className
              }))
            });
            
            bundleItems.forEach((item, index) => {
              console.log('SubscriptionSelector: DEBUG - Looking for item ' + (index + 1), {
                productId: item.product_id,
                variantId: item.variant_id,
                title: item.title
              });
              
              // Try multiple selectors in order of preference
              let itemElement = null;
              
              // 1. Try by variant ID (most specific)
              itemElement = cartDrawer.querySelector(`[data-variant-id="${item.variant_id}"]`);
              
              // 2. Try by product ID
              if (!itemElement) {
                itemElement = cartDrawer.querySelector(`[data-product-id="${item.product_id}"]`);
              }
              
              // 3. Try by key (if available in DOM)
              if (!itemElement && item.key) {
                itemElement = cartDrawer.querySelector(`[data-key="${item.key}"]`);
              }
              
              // 4. Try finding by title text (less reliable but sometimes works)
              if (!itemElement && item.title) {
                const allItems = Array.from(cartDrawer.querySelectorAll('*'));
                itemElement = allItems.find(el => {
                  const text = el.textContent || '';
                  return text.includes(item.title.split(' - ')[0]); // Match product name part
                });
              }
              
              if (itemElement) {
                // Try multiple ways to get the handle
                let handle = itemElement.dataset.handle || 
                            itemElement.getAttribute('data-handle') ||
                            itemElement.getAttribute('data-product-handle') ||
                            itemElement.dataset.productHandle;
                
                // If handle not found, try to extract from href or data-url
                if (!handle) {
                  const href = itemElement.querySelector('a[href*="/products/"]')?.getAttribute('href');
                  if (href) {
                    const match = href.match(/\/products\/([^/?]+)/);
                    if (match && match[1]) {
                      handle = match[1];
                    }
                  }
                }
                
                console.log('SubscriptionSelector: DEBUG - Found element for item', {
                  productId: item.product_id,
                  variantId: item.variant_id,
                  element: itemElement.tagName,
                  hasHandle: !!handle,
                  handle: handle,
                  allAttributes: Array.from(itemElement.attributes).slice(0, 10).map(attr => ({
                    name: attr.name,
                    value: attr.value.substring(0, 50) // Limit value length for logging
                  }))
                });
                
                if (handle) {
                  productHandleMap[item.product_id] = handle;
                  console.log('SubscriptionSelector: Found product handle in DOM', {
                    productId: item.product_id,
                    variantId: item.variant_id,
                    handle: handle
                  });
                } else {
                  console.warn('SubscriptionSelector: DEBUG - Element found but no handle attribute', {
                    productId: item.product_id,
                    variantId: item.variant_id,
                    element: itemElement.outerHTML.substring(0, 200)
                  });
                }
              } else {
                console.warn('SubscriptionSelector: DEBUG - No element found for item', {
                  productId: item.product_id,
                  variantId: item.variant_id,
                  title: item.title,
                  searchedSelectors: [
                    `[data-variant-id="${item.variant_id}"]`, 
                    `[data-product-id="${item.product_id}"]`,
                    `[data-key="${item.key}"]`
                  ]
                });
              }
            });
          } else {
            console.error('SubscriptionSelector: DEBUG - Cart drawer not found!', {
              searchedSelectors: ['#CartDrawer', '.cart-drawer', '[id*="cart"]', '.mini-cart'],
              documentBody: document.body ? 'exists' : 'missing',
              allElements: document.querySelectorAll('*').length
            });
          }
          
          // If we didn't find all handles in DOM, log for debugging
          console.log('SubscriptionSelector: DEBUG - Handle lookup summary', {
            found: Object.keys(productHandleMap).length,
            total: Object.keys(uniqueProducts).length,
            handles: productHandleMap,
            missing: Object.keys(uniqueProducts).filter(id => !productHandleMap[id]).map(id => {
              const item = bundleItems.find(i => i.product_id === id);
              return {
                productId: id,
                variantId: item?.variant_id,
                title: item?.title
              };
            })
          });
          
          if (Object.keys(productHandleMap).length < Object.keys(uniqueProducts).length) {
            console.warn('SubscriptionSelector: Not all product handles found in DOM', {
              found: Object.keys(productHandleMap).length,
              total: Object.keys(uniqueProducts).length,
              missing: Object.keys(uniqueProducts).filter(id => !productHandleMap[id])
            });
          }
          
          // Fetch product data for each unique product
          // OPTIMIZATION: Process first product sequentially to find targetGroupId, then process rest in parallel
          // First, find the selected plan's index in the first product (for position-based fallback)
          let firstProductData = null;
          const productInfos = Object.values(uniqueProducts);
          
          // Process first product first to get targetGroupId
          if (productInfos.length > 0) {
            const firstProductInfo = productInfos[0];
            await (async () => {
              const productInfo = firstProductInfo;
              const i = 0;
            try {
              console.log('SubscriptionSelector: DEBUG - Processing product ' + (i + 1) + '/' + Object.values(uniqueProducts).length, {
                productId: productInfo.product_id,
                variantId: productInfo.variant_id
              });
              
              let productHandle = productHandleMap[productInfo.product_id];
              console.log('SubscriptionSelector: DEBUG - Initial handle lookup', {
                productId: productInfo.product_id,
                handleFromMap: productHandle,
                handleMapKeys: Object.keys(productHandleMap),
                handleMapValues: Object.values(productHandleMap)
              });
              
              // If not found in DOM, try to get from variant data or construct from title
              if (!productHandle) {
                console.log('SubscriptionSelector: DEBUG - Handle not in map, trying alternatives', {
                  productId: productInfo.product_id,
                  hasVariant: !!productInfo.variant,
                  variantKeys: productInfo.variant ? Object.keys(productInfo.variant) : []
                });
                
                // Try to extract from variant if available
                if (productInfo.variant && productInfo.variant.product) {
                  // Variant might have product handle
                  productHandle = productInfo.variant.product?.handle;
                  console.log('SubscriptionSelector: DEBUG - Handle from variant', {
                    productId: productInfo.product_id,
                    handle: productHandle
                  });
                }
                
                // Try to extract handle from cart item URL (more reliable than constructing from title)
                if (!productHandle && bundleItems.length > 0) {
                  const item = bundleItems.find(i => i.product_id === productInfo.product_id);
                  if (item && item.url) {
                    const urlMatch = item.url.match(/\/products\/([^?]+)/);
                    if (urlMatch && urlMatch[1]) {
                      productHandle = urlMatch[1];
                      console.log('SubscriptionSelector: DEBUG - Handle extracted from cart item URL', {
                        productId: productInfo.product_id,
                        url: item.url,
                        extractedHandle: productHandle
                      });
                    }
                  }
                }
                
                // Last resort: try to construct handle from product title (not ideal but better than nothing)
                if (!productHandle && bundleItems.length > 0) {
                  const item = bundleItems.find(i => i.product_id === productInfo.product_id);
                  if (item && item.title) {
                    // Convert title to handle-like format with better mapping for known products
                    let rawHandle = item.title.toLowerCase()
                      .replace(/[^a-z0-9]+/g, '-')
                      .replace(/^-+|-+$/g, '');

                    // Handle known product name variations that don't match actual handles
                    const handleMappings = {
                      'sunny-buddy-10-pack': 'sunbutta-choco-chip-10-pack',
                      'brownie-chocolate-chip-10-pack': 'brownie-choco-chip-10-pack',
                      'vanilla-spice-10-pack': 'vanilla-spice-10-pack', // Try exact match first
                      'vanilla-spice': 'vanilla-spice-10-pack', // Fallback if no pack size in title
                      // Add more mappings as needed for other products
                    };

                    productHandle = handleMappings[rawHandle] || rawHandle;

                    console.log('SubscriptionSelector: DEBUG - Constructed handle from title', {
                      productId: productInfo.product_id,
                      title: item.title,
                      rawHandle: rawHandle,
                      finalHandle: productHandle,
                      usedMapping: !!handleMappings[rawHandle]
                    });
                    
                    // Additional fallback: try to extract handle from product URL if available
                    if (!productHandle && item.url) {
                      const urlMatch = item.url.match(/\/products\/([^?]+)/);
                      if (urlMatch && urlMatch[1]) {
                        productHandle = urlMatch[1];
                        console.log('SubscriptionSelector: DEBUG - Extracted handle from product URL', {
                          productId: productInfo.product_id,
                          url: item.url,
                          extractedHandle: productHandle
                        });
                      }
                    }
                  }
                }
              }
              
              if (productHandle) {
                console.log('SubscriptionSelector: DEBUG - Fetching product JSON', {
                  productId: productInfo.product_id,
                  productHandle: productHandle,
                  url: '/products/' + productHandle + '.js'
                });
                
                try {
                  const productResponse = await fetch(`/products/${productHandle}.js`);
                  console.log('SubscriptionSelector: DEBUG - Product fetch response', {
                    productId: productInfo.product_id,
                    productHandle: productHandle,
                    status: productResponse.status,
                    ok: productResponse.ok,
                    statusText: productResponse.statusText
                  });
                  
                  if (productResponse.ok) {
                    const productData = await productResponse.json();
                    console.log('SubscriptionSelector: DEBUG - Product data received successfully', {
                      productId: productInfo.product_id,
                      productHandle: productHandle,
                      variantsCount: productData.variants ? productData.variants.length : 0,
                      firstVariantId: productData.variants && productData.variants[0] ? productData.variants[0].id : null,
                      targetVariantId: productInfo.variant_id
                    });
                    
                    // Find the plan with matching name
                    // Check all variants, not just first one
                    if (productData.variants && productData.variants.length > 0) {
                      // Find variant matching our variant_id
                      let targetVariant = productData.variants.find(v => v.id === productInfo.variant_id);
                      console.log('SubscriptionSelector: DEBUG - Variant matching', {
                        productId: productInfo.product_id,
                        targetVariantId: productInfo.variant_id,
                        foundExactMatch: !!targetVariant,
                        allVariantIds: productData.variants.map(v => v.id)
                      });
                      
                      if (!targetVariant) {
                        // Fallback to first variant
                        targetVariant = productData.variants[0];
                        console.log('SubscriptionSelector: DEBUG - Using first variant as fallback', {
                          productId: productInfo.product_id,
                          fallbackVariantId: targetVariant.id
                        });
                      }
                      
                      console.log('SubscriptionSelector: DEBUG - Checking selling plan allocations', {
                        productId: productInfo.product_id,
                        variantId: targetVariant.id,
                        hasAllocations: !!targetVariant.selling_plan_allocations,
                        allocationsCount: targetVariant.selling_plan_allocations ? targetVariant.selling_plan_allocations.length : 0,
                        planName: planName
                      });
                      
                      if (targetVariant.selling_plan_allocations) {
                        // Store first product data for position-based fallback
                        // Try to find the selected plan by ID first, then by name
                        if (i === 0 && !firstProductData) {
                          firstProductData = {
                            productId: productInfo.product_id,
                            allocations: targetVariant.selling_plan_allocations
                          };
                          // First try to find by plan ID
                          let planIndex = targetVariant.selling_plan_allocations.findIndex(a => 
                            a.selling_plan && String(a.selling_plan.id) === String(sellingPlan)
                          );
                          
                          // If not found by ID, try to find by plan name
                          if (planIndex === -1 && planName) {
                            const normalizedPlanName = planName.trim().toLowerCase();
                            planIndex = targetVariant.selling_plan_allocations.findIndex(a => {
                              if (!a.selling_plan || !a.selling_plan.name) return false;
                              const allocationName = a.selling_plan.name.trim().toLowerCase();
                              return allocationName === normalizedPlanName ||
                                     allocationName.includes(normalizedPlanName) ||
                                     normalizedPlanName.includes(allocationName);
                            });
                          }
                          
                          if (planIndex !== -1) {
                            selectedPlanIndex = planIndex;
                            console.log('SubscriptionSelector: Found selected plan index in first product', {
                              productId: productInfo.product_id,
                              selectedPlanId: sellingPlan,
                              planName: planName,
                              planIndex: planIndex,
                              foundPlanName: targetVariant.selling_plan_allocations[planIndex].selling_plan?.name,
                              foundPlanId: targetVariant.selling_plan_allocations[planIndex].selling_plan?.id
                            });
                          } else {
                            console.warn('SubscriptionSelector: Could not find selected plan in first product', {
                              productId: productInfo.product_id,
                              selectedPlanId: sellingPlan,
                              planName: planName,
                              availablePlanIds: targetVariant.selling_plan_allocations.map(a => a.selling_plan?.id),
                              availablePlanNames: targetVariant.selling_plan_allocations.map(a => a.selling_plan?.name)
                            });
                          }
                        }
                        
                        // Normalize plan names for comparison (trim, lowercase)
                        const normalizedPlanName = planName ? planName.trim().toLowerCase() : '';
                        const availablePlans = targetVariant.selling_plan_allocations.map(a => ({
                          id: a.selling_plan?.id,
                          name: a.selling_plan?.name,
                          normalized: a.selling_plan?.name ? a.selling_plan.name.trim().toLowerCase() : '',
                          matches: a.selling_plan?.name ? a.selling_plan.name.trim().toLowerCase() === normalizedPlanName : false
                        }));
                        
                        // Log actual plan names as strings for debugging
                        const planNamesList = targetVariant.selling_plan_allocations.map(a => 
                          a.selling_plan?.name || 'null'
                        );
                        const planIdsList = targetVariant.selling_plan_allocations.map(a => 
                          a.selling_plan?.id || 'null'
                        );
                        console.log('SubscriptionSelector: ========== PLAN MATCHING DEBUG START ==========');
                        console.log('SubscriptionSelector: Product Info', {
                          productId: productInfo.product_id,
                          productHandle: productHandle,
                          variantId: productInfo.variant_id,
                          productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown'
                        });
                        console.log('SubscriptionSelector: Search Parameters', {
                          searchPlanName: planName,
                          normalizedSearchName: normalizedPlanName,
                          selectedPlanId: sellingPlan,
                          searchPlanNameLength: planName ? planName.length : 0
                        });
                        console.log('SubscriptionSelector: Available Plans Summary', {
                          planCount: planNamesList.length,
                          planNames: planNamesList,
                          planIds: planIdsList
                        });
                        // Log each plan name as a separate string so it's visible in console
                        console.log('SubscriptionSelector: Plan Names (as strings):', planNamesList.join(' | '));
                        console.log('SubscriptionSelector: Plan IDs (as strings):', planIdsList.join(' | '));
                        console.log('SubscriptionSelector: About to loop through', targetVariant.selling_plan_allocations.length, 'allocations');
                        
                        // Also log each plan individually for clarity with detailed comparison
                        console.log('SubscriptionSelector: Full allocations array:', JSON.stringify(targetVariant.selling_plan_allocations, null, 2));
                        targetVariant.selling_plan_allocations.forEach((allocation, index) => {
                          console.log(`SubscriptionSelector: Allocation ${index + 1} full object:`, JSON.stringify(allocation, null, 2));
                          console.log(`SubscriptionSelector: Processing allocation ${index + 1}, has selling_plan:`, !!allocation.selling_plan);
                          console.log(`SubscriptionSelector: Allocation ${index + 1} keys:`, Object.keys(allocation || {}));
                          if (allocation.selling_plan) {
                            const allocName = allocation.selling_plan.name || 'null';
                            const allocNormalized = allocName !== 'null' ? allocName.trim().toLowerCase() : 'null';
                            const exactMatch = allocNormalized === normalizedPlanName;
                            const containsMatch = allocNormalized.includes(normalizedPlanName) || normalizedPlanName.includes(allocNormalized);
                            
                            // Log as separate strings (not objects) so they're always visible and not collapsed
                            console.log(`SubscriptionSelector: ════ PLAN ${index + 1}/${planNamesList.length} ════`);
                            console.log(`SubscriptionSelector: PLAN ${index + 1} ID:`, String(allocation.selling_plan.id));
                            console.log(`SubscriptionSelector: PLAN ${index + 1} NAME:`, String(allocName));
                            console.log(`SubscriptionSelector: PLAN ${index + 1} NORMALIZED:`, String(allocNormalized));
                            console.log(`SubscriptionSelector: PLAN ${index + 1} EXACT MATCH:`, String(exactMatch));
                            console.log(`SubscriptionSelector: PLAN ${index + 1} CONTAINS MATCH:`, String(containsMatch));
                            console.log(`SubscriptionSelector: PLAN ${index + 1} IS SELECTED:`, String(allocation.selling_plan.id) === String(sellingPlan));
                            console.log(`SubscriptionSelector: ════ END PLAN ${index + 1} ════`);
                          }
                        });
                        console.log('SubscriptionSelector: ========== PLAN MATCHING DEBUG END ==========');
                        
                        // CRITICAL FIX: Some variants may not support all selling plans
                        // For bundle items, we need to find the BEST available plan for each product
                        let found = false;

                        console.log('SubscriptionSelector: DEBUG - Attempting to match product', {
                          productId: productInfo.product_id,
                          productHandle: productHandle,
                          hasTargetGroupId: !!targetGroupId,
                          targetGroupId: targetGroupId,
                          sellingPlan: sellingPlan,
                          allocationsCount: targetVariant.selling_plan_allocations?.length || 0
                        });

                        if (targetGroupId) {
                          // Match by group_id (this works across all products!)
                          console.log('SubscriptionSelector: DEBUG - Matching by group_id', {
                            productId: productInfo.product_id,
                            targetGroupId: targetGroupId,
                            allocationsToCheck: targetVariant.selling_plan_allocations.length
                          });
                          for (const allocation of targetVariant.selling_plan_allocations) {
                            console.log('SubscriptionSelector: DEBUG - Checking allocation', {
                              productId: productInfo.product_id,
                              allocationGroupId: allocation.selling_plan_group_id,
                              targetGroupId: targetGroupId,
                              matches: allocation.selling_plan_group_id === targetGroupId,
                              planId: allocation.selling_plan_id
                            });
                            if (allocation.selling_plan_group_id === targetGroupId) {
                              productPlanMap[productInfo.product_id] = allocation.selling_plan_id;
                              console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from product JSON!', {
                                productId: productInfo.product_id,
                                productHandle: productHandle,
                                groupId: targetGroupId,
                                planId: allocation.selling_plan_id
                              });
                              found = true;
                              break;
                            }
                          }
                          if (!found) {
                            // FALLBACK: If group_id doesn't match, find the closest equivalent plan
                            // This handles cases where different products have different plan configurations
                            console.log('SubscriptionSelector: ⚠️ No exact group_id match, trying fallback approach', {
                              productId: productInfo.product_id,
                              targetGroupId: targetGroupId,
                              availableAllocations: targetVariant.selling_plan_allocations.length
                            });

                            // Find plans with similar pricing patterns or use position-based matching
                            if (targetVariant.selling_plan_allocations.length > 0) {
                              // For now, just use the first available plan as fallback
                              // This is better than failing completely
                              const fallbackPlan = targetVariant.selling_plan_allocations[0];
                              productPlanMap[productInfo.product_id] = fallbackPlan.selling_plan_id;
                              console.log('SubscriptionSelector: ⚠️ Using fallback plan (first available)', {
                                productId: productInfo.product_id,
                                fallbackPlanId: fallbackPlan.selling_plan_id,
                                reason: 'No exact group_id match found'
                              });
                              found = true;
                            }
                          }
                        } else if (sellingPlan) {
                          // First product: Find the selected plan's group_id
                          console.log('SubscriptionSelector: DEBUG - Finding targetGroupId from first product', {
                            productId: productInfo.product_id,
                            sellingPlan: sellingPlan,
                            allocationsCount: targetVariant.selling_plan_allocations.length
                          });
                          for (const allocation of targetVariant.selling_plan_allocations) {
                            console.log('SubscriptionSelector: DEBUG - Checking allocation for selected plan', {
                              productId: productInfo.product_id,
                              allocationPlanId: allocation.selling_plan_id,
                              sellingPlan: sellingPlan,
                              matches: String(allocation.selling_plan_id) === String(sellingPlan),
                              groupId: allocation.selling_plan_group_id
                            });
                            if (String(allocation.selling_plan_id) === String(sellingPlan)) {
                              targetGroupId = allocation.selling_plan_group_id;
                              productPlanMap[productInfo.product_id] = allocation.selling_plan_id;
                              console.log('SubscriptionSelector: ✅✅✅ Found target group_id from first product JSON!', {
                                selectedPlanId: sellingPlan,
                                groupId: targetGroupId,
                                planId: allocation.selling_plan_id,
                                productId: productInfo.product_id,
                                productHandle: productHandle
                              });
                              found = true;
                              break;
                            }
                          }
                          if (!found) {
                            console.warn('SubscriptionSelector: ⚠️ Could not find selected plan in first product JSON', {
                              productId: productInfo.product_id,
                              sellingPlan: sellingPlan,
                              availablePlanIds: targetVariant.selling_plan_allocations.map(a => a.selling_plan_id)
                            });

                            // FALLBACK: Use the first available plan for first product
                            if (targetVariant.selling_plan_allocations.length > 0) {
                              const fallbackPlan = targetVariant.selling_plan_allocations[0];
                              targetGroupId = fallbackPlan.selling_plan_group_id;
                              productPlanMap[productInfo.product_id] = fallbackPlan.selling_plan_id;
                              console.log('SubscriptionSelector: ⚠️ Using fallback plan for first product', {
                                productId: productInfo.product_id,
                                fallbackPlanId: fallbackPlan.selling_plan_id,
                                newTargetGroupId: targetGroupId
                              });
                              found = true;
                            }
                          }
                        }
                        
                        // The first loop above handles all matching strategies, so we don't need a second loop
                        // Position-based fallback is handled below if name matching fails
                        
                        
                        // Fallback: If name matching failed, try position-based matching
                        if (!found && selectedPlanIndex !== -1 && selectedPlanIndex < targetVariant.selling_plan_allocations.length) {
                          const planAtIndex = targetVariant.selling_plan_allocations[selectedPlanIndex];
                          if (planAtIndex && planAtIndex.selling_plan) {
                            productPlanMap[productInfo.product_id] = planAtIndex.selling_plan.id;
                            console.log('SubscriptionSelector: Found matching plan for product (position-based fallback)', {
                              productId: productInfo.product_id,
                              variantId: productInfo.variant_id,
                              productHandle: productHandle,
                              planIndex: selectedPlanIndex,
                              planId: planAtIndex.selling_plan.id,
                              planName: planAtIndex.selling_plan.name
                            });
                            found = true;
                          }
                        }
                        
                        if (!found) {
                          const actualPlanNames = targetVariant.selling_plan_allocations.map(a => ({
                            id: a.selling_plan?.id,
                            name: a.selling_plan?.name || 'null',
                            normalized: a.selling_plan?.name ? a.selling_plan.name.trim().toLowerCase() : 'null',
                            nameLength: a.selling_plan?.name ? a.selling_plan.name.length : 0
                          }));
                          console.error('SubscriptionSelector: ❌❌❌ NO MATCHING PLAN FOUND ❌❌❌');
                          console.error('SubscriptionSelector: Product:', {
                            productId: productInfo.product_id,
                            productHandle: productHandle,
                            productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown'
                          });
                          console.error('SubscriptionSelector: Searching For:', {
                            planName: planName,
                            normalized: normalizedPlanName,
                            selectedPlanId: sellingPlan,
                            selectedPlanIndex: selectedPlanIndex
                          });
                          // Log plan names as strings so they're visible
                          console.error('SubscriptionSelector: Available Plan Names (as strings):', actualPlanNames.map(p => p.name).join(' | '));
                          console.error('SubscriptionSelector: Available Plan IDs (as strings):', actualPlanNames.map(p => p.id).join(' | '));
                          console.error('SubscriptionSelector: Available Plans Details:', actualPlanNames.map((p, idx) => ({
                            index: idx,
                            id: p.id,
                            name: p.name,
                            normalized: p.normalized,
                            exactMatch: p.normalized === normalizedPlanName,
                            searchContainsPlan: normalizedPlanName.includes(p.normalized),
                            planContainsSearch: p.normalized.includes(normalizedPlanName)
                          })));
                          console.error('SubscriptionSelector: Why No Match?', {
                            searchWords: normalizedPlanName.split(/\s+/),
                            availablePlanWords: actualPlanNames.map(p => p.normalized.split(/\s+/)),
                            commonWords: actualPlanNames.map(p => {
                              const planWords = p.normalized.split(/\s+/);
                              const searchWords = normalizedPlanName.split(/\s+/);
                              return {
                                planName: p.name,
                                commonWords: planWords.filter(w => searchWords.includes(w)),
                                missingWords: searchWords.filter(w => !planWords.includes(w))
                              };
                            })
                          });
                        }
                      } else {
                        console.warn('SubscriptionSelector: DEBUG - No selling plan allocations', {
                          productId: productInfo.product_id,
                          variantId: targetVariant.id
                        });
                      }
                    }
                  } else {
                    console.warn('SubscriptionSelector: DEBUG - Product fetch failed', {
                      productId: productInfo.product_id,
                      productHandle: productHandle,
                      status: productResponse.status,
                      statusText: productResponse.statusText,
                      url: `/products/${productHandle}.js`
                    });
                    
                    // FALLBACK 1: Try alternative product handles or fetch methods
                    if (!productPlanMap[productInfo.product_id] && productResponse.status === 404) {
                      console.log('SubscriptionSelector: DEBUG - Trying alternative product fetch methods', {
                        productId: productInfo.product_id,
                        variantId: productInfo.variant_id,
                        failedHandle: productHandle
                      });
                      
                      // Try fetching using product ID (Shopify API might support this)
                      // Note: This is a fallback - most Shopify stores don't expose product by ID
                      const alternativeHandles = [];
                      const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                      
                      // Try different handle variations
                      if (cartItem && cartItem.title) {
                        const titleVariations = [
                          cartItem.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''),
                          cartItem.title.toLowerCase().replace(/\s+/g, '-'),
                          cartItem.title.toLowerCase().replace(/[^a-z0-9\s]+/g, '').replace(/\s+/g, '-')
                        ];
                        alternativeHandles.push(...titleVariations);
                      }
                      
                      // Try fetching with alternative handles
                      for (const altHandle of alternativeHandles) {
                        if (altHandle && altHandle !== productHandle) {
                          try {
                            console.log('SubscriptionSelector: DEBUG - Trying alternative handle', {
                              productId: productInfo.product_id,
                              alternativeHandle: altHandle
                            });
                            const altResponse = await fetch(`/products/${altHandle}.js`);
                            if (altResponse.ok) {
                              const altProductData = await altResponse.json();
                              // Check if this product matches our product_id
                              if (altProductData.id === productInfo.product_id || 
                                  (altProductData.variants && altProductData.variants.some(v => v.id === productInfo.variant_id))) {
                                console.log('SubscriptionSelector: ✅ Found product using alternative handle!', {
                                  productId: productInfo.product_id,
                                  alternativeHandle: altHandle
                                });
                                // Process this product data (same logic as above)
                                const targetVariant = altProductData.variants.find(v => v.id === productInfo.variant_id) || altProductData.variants[0];
                                if (targetVariant?.selling_plan_allocations && targetGroupId) {
                                  for (const allocation of targetVariant.selling_plan_allocations) {
                                    if (allocation.selling_plan_group_id === targetGroupId) {
                                      productPlanMap[productInfo.product_id] = allocation.selling_plan_id;
                                      console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from alternative product JSON!', {
                                        productId: productInfo.product_id,
                                        alternativeHandle: altHandle,
                                        groupId: targetGroupId,
                                        planId: allocation.selling_plan_id
                                      });
                                      break;
                                    }
                                  }
                                }
                                if (productPlanMap[productInfo.product_id]) break; // Success, stop trying
                              }
                            }
                          } catch (altError) {
                            // Continue to next alternative
                            console.log('SubscriptionSelector: DEBUG - Alternative handle also failed', {
                              alternativeHandle: altHandle,
                              error: altError.message
                            });
                          }
                        }
                      }
                    }
                    
                    // FALLBACK 2: If product JSON fetch failed but we have targetGroupId, try cart variant data
                    // This is critical for products like "Vanilla Spice" where product JSON might not be accessible
                    if (!productPlanMap[productInfo.product_id] && targetGroupId) {
                      const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                      console.log('SubscriptionSelector: DEBUG - Checking cart variant data for fallback', {
                        productId: productInfo.product_id,
                        hasCartItem: !!cartItem,
                        hasVariant: !!cartItem?.variant,
                        hasAllocations: !!cartItem?.variant?.selling_plan_allocations,
                        cartItemKeys: cartItem ? Object.keys(cartItem) : [],
                        variantKeys: cartItem?.variant ? Object.keys(cartItem.variant) : []
                      });
                      
                      if (cartItem?.variant?.selling_plan_allocations) {
                        const allocations = cartItem.variant.selling_plan_allocations;
                        console.log('SubscriptionSelector: DEBUG - Cart variant allocations found', {
                          productId: productInfo.product_id,
                          allocationsCount: allocations.length,
                          allocations: allocations.map(a => ({
                            groupId: a.selling_plan_group_id,
                            planId: a.selling_plan_id || a.selling_plan?.id
                          }))
                        });
                        for (const allocation of allocations) {
                          // Check both formats: selling_plan_id (product JSON) or selling_plan.id (cart)
                          const allocationGroupId = allocation.selling_plan_group_id;
                          if (allocationGroupId === targetGroupId) {
                            const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                            if (planId) {
                              productPlanMap[productInfo.product_id] = planId;
                              console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from cart variant data (fallback)!', {
                                productId: productInfo.product_id,
                                productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                                groupId: targetGroupId,
                                planId: planId,
                                reason: 'Product JSON fetch failed (404 or other error), using cart variant data'
                              });
                              break;
                            }
                          }
                        }
                      } else {
                        console.warn('SubscriptionSelector: ⚠️ No cart variant allocations available for fallback', {
                          productId: productInfo.product_id,
                          productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                          hasCartItem: !!cartItem,
                          hasVariant: !!cartItem?.variant,
                          hasAllocations: !!cartItem?.variant?.selling_plan_allocations,
                          cartItemFull: cartItem ? JSON.stringify(cartItem, null, 2).substring(0, 500) : 'no cart item'
                        });
                      }
                    } else if (!productPlanMap[productInfo.product_id]) {
                      console.warn('SubscriptionSelector: ⚠️ Product JSON fetch failed AND no targetGroupId available', {
                        productId: productInfo.product_id,
                        productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                        productHandle: productHandle,
                        status: productResponse.status
                      });
                    }
                  }
                } catch (fetchError) {
                  console.warn('SubscriptionSelector: Failed to fetch product JSON', {
                    productId: productInfo.product_id,
                    productHandle: productHandle,
                    error: fetchError,
                    errorMessage: fetchError.message,
                    errorStack: fetchError.stack
                  });
                  
                  // FALLBACK: If product JSON fetch failed but we have targetGroupId, try cart variant data
                  if (targetGroupId && !productPlanMap[productInfo.product_id]) {
                    const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                    if (cartItem?.variant?.selling_plan_allocations) {
                      const allocations = cartItem.variant.selling_plan_allocations;
                      for (const allocation of allocations) {
                        const allocationGroupId = allocation.selling_plan_group_id;
                        if (allocationGroupId === targetGroupId) {
                          const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                          if (planId) {
                            productPlanMap[productInfo.product_id] = planId;
                            console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from cart variant data (error fallback)!', {
                              productId: productInfo.product_id,
                              productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                              groupId: targetGroupId,
                              planId: planId,
                              reason: 'Product JSON fetch error, using cart variant data'
                            });
                            break;
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                console.warn('SubscriptionSelector: Could not determine product handle', {
                  productId: productInfo.product_id,
                  variantId: productInfo.variant_id,
                  handleMap: productHandleMap,
                  hasVariant: !!productInfo.variant
                });
                
                // FALLBACK: If we couldn't get product handle but we have targetGroupId, try cart variant data
                if (targetGroupId && !productPlanMap[productInfo.product_id]) {
                  const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                  if (cartItem?.variant?.selling_plan_allocations) {
                    const allocations = cartItem.variant.selling_plan_allocations;
                    for (const allocation of allocations) {
                      const allocationGroupId = allocation.selling_plan_group_id;
                      if (allocationGroupId === targetGroupId) {
                        const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                        if (planId) {
                          productPlanMap[productInfo.product_id] = planId;
                          console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from cart variant data (no handle fallback)!', {
                            productId: productInfo.product_id,
                            productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                            groupId: targetGroupId,
                            planId: planId,
                            reason: 'Could not determine product handle, using cart variant data'
                          });
                          break;
                        }
                      }
                    }
                  }
                }
              }
            } catch (error) {
              console.warn('SubscriptionSelector: Error processing product', {
                productId: productInfo.product_id,
                error: error,
                errorMessage: error.message,
                errorStack: error.stack
              });
            }
            })();
          }
          
          // OPTIMIZATION: Process remaining products in parallel (after first product found targetGroupId)
          if (productInfos.length > 1) {
            console.log('SubscriptionSelector: ⚡ Processing remaining products in parallel for faster execution', {
              remainingProducts: productInfos.length - 1,
              hasTargetGroupId: !!targetGroupId
            });
            
            const remainingProducts = productInfos.slice(1);
            const productPromises = remainingProducts.map((productInfo, index) => {
              return (async () => {
                const i = index + 1; // Keep original index for logging
                try {
                  console.log('SubscriptionSelector: DEBUG - Processing product ' + (i + 1) + '/' + productInfos.length + ' (parallel)', {
                    productId: productInfo.product_id,
                    variantId: productInfo.variant_id
                  });
                  
                  let productHandle = productHandleMap[productInfo.product_id];
                  console.log('SubscriptionSelector: DEBUG - Initial handle lookup', {
                    productId: productInfo.product_id,
                    handleFromMap: productHandle,
                    handleMapKeys: Object.keys(productHandleMap),
                    handleMapValues: Object.values(productHandleMap)
                  });
                  
                  // If not found in DOM, try to get from variant data or construct from title
                  if (!productHandle) {
                    console.log('SubscriptionSelector: DEBUG - Handle not in map, trying alternatives', {
                      productId: productInfo.product_id,
                      hasVariant: !!productInfo.variant,
                      variantKeys: productInfo.variant ? Object.keys(productInfo.variant) : []
                    });
                    
                    // Try to extract from variant if available
                    if (productInfo.variant && productInfo.variant.product) {
                      productHandle = productInfo.variant.product?.handle;
                      console.log('SubscriptionSelector: DEBUG - Handle from variant', {
                        productId: productInfo.product_id,
                        handle: productHandle
                      });
                    }
                    
                    // Try to extract handle from cart item URL (more reliable than constructing from title)
                    if (!productHandle && bundleItems.length > 0) {
                      const item = bundleItems.find(i => i.product_id === productInfo.product_id);
                      if (item && item.url) {
                        const urlMatch = item.url.match(/\/products\/([^?]+)/);
                        if (urlMatch && urlMatch[1]) {
                          productHandle = urlMatch[1];
                          console.log('SubscriptionSelector: DEBUG - Handle extracted from cart item URL', {
                            productId: productInfo.product_id,
                            url: item.url,
                            extractedHandle: productHandle
                          });
                        }
                      }
                    }
                    
                    // Last resort: try to construct handle from product title
                    if (!productHandle && bundleItems.length > 0) {
                      const item = bundleItems.find(i => i.product_id === productInfo.product_id);
                      if (item && item.title) {
                        let rawHandle = item.title.toLowerCase()
                          .replace(/[^a-z0-9]+/g, '-')
                          .replace(/^-+|-+$/g, '');
                        const handleMappings = {
                          'sunny-buddy-10-pack': 'sunbutta-choco-chip-10-pack',
                          'brownie-chocolate-chip-10-pack': 'brownie-choco-chip-10-pack',
                          'vanilla-spice-10-pack': 'vanilla-spice-10-pack',
                          'vanilla-spice': 'vanilla-spice-10-pack',
                        };
                        productHandle = handleMappings[rawHandle] || rawHandle;
                        console.log('SubscriptionSelector: DEBUG - Constructed handle from title', {
                          productId: productInfo.product_id,
                          title: item.title,
                          rawHandle: rawHandle,
                          finalHandle: productHandle,
                          usedMapping: !!handleMappings[rawHandle]
                        });
                        if (!productHandle && item.url) {
                          const urlMatch = item.url.match(/\/products\/([^?]+)/);
                          if (urlMatch && urlMatch[1]) {
                            productHandle = urlMatch[1];
                          }
                        }
                      }
                    }
                  }
                  
                  if (productHandle) {
                    console.log('SubscriptionSelector: DEBUG - Fetching product JSON (parallel)', {
                      productId: productInfo.product_id,
                      productHandle: productHandle,
                      url: '/products/' + productHandle + '.js'
                    });
                    
                    try {
                      const productResponse = await fetch(`/products/${productHandle}.js`);
                      console.log('SubscriptionSelector: DEBUG - Product fetch response (parallel)', {
                        productId: productInfo.product_id,
                        productHandle: productHandle,
                        status: productResponse.status,
                        ok: productResponse.ok
                      });
                      
                      if (productResponse.ok) {
                        const productData = await productResponse.json();
                        if (productData.variants && productData.variants.length > 0) {
                          let targetVariant = productData.variants.find(v => v.id === productInfo.variant_id);
                          if (!targetVariant) {
                            targetVariant = productData.variants[0];
                          }
                          
                          if (targetVariant.selling_plan_allocations) {
                            let found = false;
                            
                            if (targetGroupId) {
                              // Match by group_id (fastest path when targetGroupId is known)
                              for (const allocation of targetVariant.selling_plan_allocations) {
                                if (allocation.selling_plan_group_id === targetGroupId) {
                                  productPlanMap[productInfo.product_id] = allocation.selling_plan_id;
                                  console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from product JSON (parallel)!', {
                                    productId: productInfo.product_id,
                                    productHandle: productHandle,
                                    groupId: targetGroupId,
                                    planId: allocation.selling_plan_id
                                  });
                                  found = true;
                                  break;
                                }
                              }

                              // FALLBACK: If no exact match, use first available plan
                              if (!found && targetVariant.selling_plan_allocations.length > 0) {
                                const fallbackPlan = targetVariant.selling_plan_allocations[0];
                                productPlanMap[productInfo.product_id] = fallbackPlan.selling_plan_id;
                                console.log('SubscriptionSelector: ⚠️ Using fallback plan (parallel)', {
                                  productId: productInfo.product_id,
                                  fallbackPlanId: fallbackPlan.selling_plan_id,
                                  reason: 'No exact group_id match in parallel processing'
                                });
                                found = true;
                              }
                            }
                            
                            if (!found && sellingPlan) {
                              // Fallback: match by plan ID
                              for (const allocation of targetVariant.selling_plan_allocations) {
                                if (String(allocation.selling_plan_id) === String(sellingPlan)) {
                                  if (!targetGroupId) {
                                    targetGroupId = allocation.selling_plan_group_id;
                                  }
                                  productPlanMap[productInfo.product_id] = allocation.selling_plan_id;
                                  found = true;
                                  break;
                                }
                              }
                            }
                          }
                        }
                      } else {
                        // Handle 404 or other errors - try cart variant data fallback
                        if (targetGroupId) {
                          const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                          if (cartItem?.variant?.selling_plan_allocations) {
                            const allocations = cartItem.variant.selling_plan_allocations;
                            for (const allocation of allocations) {
                              if (allocation.selling_plan_group_id === targetGroupId) {
                                const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                                if (planId) {
                                  productPlanMap[productInfo.product_id] = planId;
                                  console.log('SubscriptionSelector: ✅✅✅ Matched by group_id from cart variant data (parallel fallback)!', {
                                    productId: productInfo.product_id,
                                    groupId: targetGroupId,
                                    planId: planId
                                  });
                                  break;
                                }
                              }
                            }
                          }
                        }
                      }
                    } catch (fetchError) {
                      console.warn('SubscriptionSelector: Failed to fetch product JSON (parallel)', {
                        productId: productInfo.product_id,
                        productHandle: productHandle,
                        error: fetchError.message
                      });
                      
                      // Fallback to cart variant data
                      if (targetGroupId) {
                        const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                        if (cartItem?.variant?.selling_plan_allocations) {
                          const allocations = cartItem.variant.selling_plan_allocations;
                          for (const allocation of allocations) {
                            if (allocation.selling_plan_group_id === targetGroupId) {
                              const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                              if (planId) {
                                productPlanMap[productInfo.product_id] = planId;
                                break;
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    // No handle - try cart variant data
                    if (targetGroupId) {
                      const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
                      if (cartItem?.variant?.selling_plan_allocations) {
                        const allocations = cartItem.variant.selling_plan_allocations;
                        for (const allocation of allocations) {
                          if (allocation.selling_plan_group_id === targetGroupId) {
                            const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                            if (planId) {
                              productPlanMap[productInfo.product_id] = planId;
                              break;
                            }
                          }
                        }
                      }
                    }
                  }
                } catch (error) {
                  console.warn('SubscriptionSelector: Error processing product (parallel)', {
                    productId: productInfo.product_id,
                    error: error.message
                  });
                }
              })();
            });
            
            // Wait for all parallel product fetches to complete
            await Promise.all(productPromises);
            console.log('SubscriptionSelector: ⚡ All parallel product fetches completed');
          }
          
          // FINAL FALLBACK: After all product JSON fetches, try to match remaining products using cart variant data
          // This handles cases where product JSON fetch failed but we have targetGroupId
          console.log('SubscriptionSelector: ========== FINAL FALLBACK CHECK ==========', {
            targetGroupId: targetGroupId,
            totalProducts: Object.keys(uniqueProducts).length,
            mappedProducts: Object.keys(productPlanMap).length,
            unmappedProductIds: Object.values(uniqueProducts).filter(p => !productPlanMap[p.product_id]).map(p => p.product_id)
          });
          
          if (targetGroupId) {
            const unmappedProducts = Object.values(uniqueProducts).filter(p => !productPlanMap[p.product_id]);
            console.log('SubscriptionSelector: FINAL FALLBACK - Processing unmapped products', {
              count: unmappedProducts.length,
              productIds: unmappedProducts.map(p => p.product_id)
            });
            
            for (const productInfo of unmappedProducts) {
              console.log('SubscriptionSelector: FINAL FALLBACK - Checking product', {
                productId: productInfo.product_id,
                variantId: productInfo.variant_id,
                targetGroupId: targetGroupId
              });
              
              const cartItem = bundleItems.find(item => item.product_id === productInfo.product_id);
              console.log('SubscriptionSelector: FINAL FALLBACK - Cart item status', {
                productId: productInfo.product_id,
                hasCartItem: !!cartItem,
                hasVariant: !!cartItem?.variant,
                hasAllocations: !!cartItem?.variant?.selling_plan_allocations,
                allocationsCount: cartItem?.variant?.selling_plan_allocations?.length || 0
              });
              
              if (cartItem?.variant?.selling_plan_allocations) {
                const allocations = cartItem.variant.selling_plan_allocations;
                let matched = false;

                // First try: exact group_id match
                for (const allocation of allocations) {
                  const allocationGroupId = allocation.selling_plan_group_id;
                  const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                  console.log('SubscriptionSelector: FINAL FALLBACK - Checking allocation', {
                    productId: productInfo.product_id,
                    allocationGroupId: allocationGroupId,
                    targetGroupId: targetGroupId,
                    matches: allocationGroupId === targetGroupId,
                    planId: planId
                  });

                  if (allocationGroupId === targetGroupId && planId) {
                    productPlanMap[productInfo.product_id] = planId;
                    console.log('SubscriptionSelector: ✅✅✅ FINAL FALLBACK - Matched by group_id from cart variant data!', {
                      productId: productInfo.product_id,
                      productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                      groupId: targetGroupId,
                      planId: planId,
                      reason: 'Final fallback after all product JSON fetches completed'
                    });
                    matched = true;
                    break;
                  }
                }

                // Second try: Use first available plan as fallback
                if (!matched && allocations.length > 0) {
                  const fallbackPlan = allocations[0];
                  const planId = fallbackPlan.selling_plan_id || fallbackPlan.selling_plan?.id;
                  if (planId) {
                    productPlanMap[productInfo.product_id] = planId;
                    console.log('SubscriptionSelector: ⚠️ FINAL FALLBACK - Using first available plan from cart variant data', {
                      productId: productInfo.product_id,
                      productTitle: bundleItems.find(item => item.product_id === productInfo.product_id)?.title || 'Unknown',
                      planId: planId,
                      reason: 'No exact group_id match, using first available plan'
                    });
                    matched = true;
                  }
                }

                if (!matched) {
                  console.warn('SubscriptionSelector: ⚠️ FINAL FALLBACK - No allocations available', {
                    productId: productInfo.product_id,
                    hasVariant: !!cartItem.variant,
                    allocationsCount: allocations.length
                  });
                }
              } else {
                console.warn('SubscriptionSelector: ⚠️ FINAL FALLBACK - No cart variant allocations', {
                  productId: productInfo.product_id,
                  hasCartItem: !!cartItem,
                  hasVariant: !!cartItem?.variant,
                  variantKeys: cartItem?.variant ? Object.keys(cartItem.variant) : []
                });
              }
            }
          } else {
            console.warn('SubscriptionSelector: ⚠️ FINAL FALLBACK - No targetGroupId available', {
              totalProducts: Object.keys(uniqueProducts).length,
              mappedProducts: Object.keys(productPlanMap).length
            });
          }
          
          console.log('SubscriptionSelector: ========== FINAL FALLBACK COMPLETE ==========', {
            targetGroupId: targetGroupId,
            totalProducts: Object.keys(uniqueProducts).length,
            mappedProducts: Object.keys(productPlanMap).length,
            finalMapping: productPlanMap
          });
          
          // Position-based matching is now handled during product processing above
          // This section is for logging only
          if (Object.keys(productPlanMap).length === 0 && selectedPlanIndex === -1) {
            console.warn('SubscriptionSelector: All matching methods failed - no plan mappings found', {
              selectedPlanId: sellingPlan,
              planName: planName,
              totalProducts: Object.keys(uniqueProducts).length
            });
          }
          
          // Create detailed summary of all products
          const productSummary = Object.values(uniqueProducts).map(p => ({
            productId: p.product_id,
            variantId: p.variant_id,
            productTitle: bundleItems.find(item => item.product_id === p.product_id)?.title || 'Unknown',
            hasMapping: !!productPlanMap[p.product_id],
            mappedPlanId: productPlanMap[p.product_id] || null,
            hasCartItem: !!bundleItems.find(item => item.product_id === p.product_id),
            hasCartAllocations: !!(bundleItems.find(item => item.product_id === p.product_id)?.variant?.selling_plan_allocations)
          }));
          
          console.log('SubscriptionSelector: ========== PRODUCT PLAN MAPPING SUMMARY ==========');
          console.log('SubscriptionSelector: Overall Stats', {
            planName: planName,
            mappedProducts: Object.keys(productPlanMap).length,
            totalProducts: Object.keys(uniqueProducts).length,
            successRate: `${Math.round((Object.keys(productPlanMap).length / Object.keys(uniqueProducts).length) * 100)}%`,
            targetGroupId: targetGroupId,
            handlesFound: Object.keys(productHandleMap).length
          });
          console.log('SubscriptionSelector: Detailed Product Summary', productSummary);
          console.log('SubscriptionSelector: Plan ID Mapping', productPlanMap);
          console.log('SubscriptionSelector: ========== END MAPPING SUMMARY ==========');
          
          // Track product data fetching phase timing
          performanceTiming.steps.productDataFetching = performance.now() - performanceTiming.startTime - performanceTiming.steps.initialCartFetch;
          console.log('SubscriptionSelector: ⏱️ Product data fetching phase took', performanceTiming.steps.productDataFetching.toFixed(2), 'ms');
        } catch (error) {
          console.warn('SubscriptionSelector: Error fetching product data, will use provided plan ID', error);
          performanceTiming.steps.productDataFetching = performance.now() - performanceTiming.startTime - performanceTiming.steps.initialCartFetch;
        }
      }
      
      // Track start of item update phase
      const itemUpdatePhaseStart = performance.now();
      
      for (let index = 0; index < bundleItems.length; index++) {
        const originalItem = bundleItems[index];
        const isLast = index === bundleItems.length - 1;
        
        // Find the current item in the updated cart by matching variant_id and bundle_id
        // Keys change after updates, so we match by variant_id + bundle_id
        // Use findIndex to get both the item and its position in one operation
        const itemIndex = currentCartData.items.findIndex(cartItem => 
          cartItem.variant_id === originalItem.variant_id &&
          cartItem.properties &&
          cartItem.properties['_bundle'] === 'true' &&
          cartItem.properties['_bundle_id'] === bundleId
        );
        
        if (itemIndex === -1) {
          console.warn('SubscriptionSelector: Item not found in current cart', {
            variantId: originalItem.variant_id,
            title: originalItem.title,
            bundleId: bundleId
          });
          results.push({ error: true, item: originalItem, errorMessage: 'Item not found in cart after previous update' });
          continue;
        }
        
        const currentItem = currentCartData.items[itemIndex];
        
        // Calculate the 1-based line index from the array position
        // Required by Shopify API when updating selling_plan
        // lineIndex is 1-based (first item is line 1, not line 0)
        const lineIndex = itemIndex + 1;
        
        // For Recharge: Use product-specific plan ID if available
        // CRITICAL: Don't use the original plan ID if we don't have a product-specific mapping
        // Each product has different plan IDs for the same plan name
        let planIdToUse = null;
        if (planName && sellingPlan) {
          if (productPlanMap[currentItem.product_id]) {
            planIdToUse = productPlanMap[currentItem.product_id];
            console.log('SubscriptionSelector: Using product-specific plan ID for Recharge', {
              productId: currentItem.product_id,
              productTitle: currentItem.title,
              planName: planName,
              planId: planIdToUse,
              originalPlanId: sellingPlan
            });
          } else {
            // No product-specific plan found - try to find it from cart variant data as last resort
            console.warn('SubscriptionSelector: No product-specific plan ID found in mapping, trying cart variant data', {
              productId: currentItem.product_id,
              productTitle: currentItem.title,
              planName: planName,
              originalPlanId: sellingPlan,
              mappedProducts: Object.keys(productPlanMap).length,
              targetGroupId: targetGroupId
            });
            
            // FALLBACK: If targetGroupId is still null, try to find it from current item's cart variant data
            // This handles cases where the initial search didn't find targetGroupId
            if (!targetGroupId && currentItem.variant?.selling_plan_allocations && sellingPlan) {
              const allocations = currentItem.variant.selling_plan_allocations;
              console.log('SubscriptionSelector: DEBUG - Trying to find targetGroupId from current item', {
                productId: currentItem.product_id,
                allocationsCount: allocations.length,
                sellingPlan: sellingPlan
              });
              for (const allocation of allocations) {
                const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                console.log('SubscriptionSelector: DEBUG - Checking allocation for targetGroupId', {
                  productId: currentItem.product_id,
                  planId: planId,
                  sellingPlan: sellingPlan,
                  matches: planId && String(planId) === String(sellingPlan),
                  groupId: allocation.selling_plan_group_id
                });
                if (planId && String(planId) === String(sellingPlan)) {
                  targetGroupId = allocation.selling_plan_group_id;
                  console.log('SubscriptionSelector: ✅ Found targetGroupId from current item cart variant data!', {
                    productId: currentItem.product_id,
                    productTitle: currentItem.title,
                    selectedPlanId: sellingPlan,
                    groupId: targetGroupId,
                    planId: planId
                  });
                  break;
                }
              }
            }
            
            // Last resort: try to find plan from cart variant data if we have targetGroupId
            if (targetGroupId && currentItem.variant?.selling_plan_allocations) {
              const allocations = currentItem.variant.selling_plan_allocations;
              console.log('SubscriptionSelector: DEBUG - Looking for plan ID by group_id in current item', {
                productId: currentItem.product_id,
                targetGroupId: targetGroupId,
                allocationsCount: allocations.length
              });

              let foundCartPlan = false;
              for (const allocation of allocations) {
                console.log('SubscriptionSelector: DEBUG - Checking allocation for plan ID', {
                  productId: currentItem.product_id,
                  allocationGroupId: allocation.selling_plan_group_id,
                  targetGroupId: targetGroupId,
                  matches: allocation.selling_plan_group_id === targetGroupId,
                  planId: allocation.selling_plan_id || allocation.selling_plan?.id
                });
                if (allocation.selling_plan_group_id === targetGroupId) {
                  const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                  if (planId) {
                    planIdToUse = planId;
                    console.log('SubscriptionSelector: ✅ Found plan ID from cart variant data (last resort)', {
                      productId: currentItem.product_id,
                      productTitle: currentItem.title,
                      planId: planIdToUse,
                      groupId: targetGroupId
                    });
                    foundCartPlan = true;
                    break;
                  }
                }
              }

              // FALLBACK: If no exact match in cart data, use first available plan
              if (!foundCartPlan && allocations.length > 0) {
                const fallbackPlan = allocations[0];
                const planId = fallbackPlan.selling_plan_id || fallbackPlan.selling_plan?.id;
                if (planId) {
                  planIdToUse = planId;
                  console.log('SubscriptionSelector: ⚠️ Using fallback plan from cart variant data', {
                    productId: currentItem.product_id,
                    productTitle: currentItem.title,
                    planId: planIdToUse,
                    reason: 'No exact group_id match in cart variant data'
                  });
                }
              }
            } else if (!planIdToUse && targetGroupId) {
              // EXTRA FALLBACK: If cart variant data is missing, try fetching fresh cart data
              // Sometimes cart variant data becomes available after other items are updated
              console.log('SubscriptionSelector: DEBUG - Cart variant data missing, trying fresh cart fetch', {
                productId: currentItem.product_id,
                hasVariant: !!currentItem.variant,
                hasAllocations: !!currentItem.variant?.selling_plan_allocations,
                targetGroupId: targetGroupId
              });
              try {
                const freshCartResponse = await fetch('/cart.js');
                const freshCartData = await freshCartResponse.json();
                const freshCartItem = freshCartData.items.find(item => 
                  item.variant_id === currentItem.variant_id &&
                  item.properties &&
                  item.properties['_bundle'] === 'true' &&
                  item.properties['_bundle_id'] === bundleId
                );
                if (freshCartItem?.variant?.selling_plan_allocations) {
                  const allocations = freshCartItem.variant.selling_plan_allocations;
                  console.log('SubscriptionSelector: DEBUG - Fresh cart data has allocations!', {
                    productId: currentItem.product_id,
                    allocationsCount: allocations.length
                  });

                  let foundFreshPlan = false;
                  for (const allocation of allocations) {
                    if (allocation.selling_plan_group_id === targetGroupId) {
                      const planId = allocation.selling_plan_id || allocation.selling_plan?.id;
                      if (planId) {
                        planIdToUse = planId;
                        console.log('SubscriptionSelector: ✅✅✅ Found plan ID from fresh cart variant data!', {
                          productId: currentItem.product_id,
                          productTitle: currentItem.title,
                          planId: planIdToUse,
                          groupId: targetGroupId,
                          reason: 'Cart variant data became available after other items updated'
                        });
                        foundFreshPlan = true;
                        break;
                      }
                    }
                  }

                  // FALLBACK: Use first available plan from fresh cart data
                  if (!foundFreshPlan && allocations.length > 0) {
                    const fallbackPlan = allocations[0];
                    const planId = fallbackPlan.selling_plan_id || fallbackPlan.selling_plan?.id;
                    if (planId) {
                      planIdToUse = planId;
                      console.log('SubscriptionSelector: ⚠️ Using fallback plan from fresh cart variant data', {
                        productId: currentItem.product_id,
                        productTitle: currentItem.title,
                        planId: planIdToUse,
                        reason: 'No exact group_id match in fresh cart data'
                      });
                    }
                  }
                } else {
                  console.warn('SubscriptionSelector: DEBUG - Fresh cart data also missing allocations', {
                    productId: currentItem.product_id,
                    hasFreshCartItem: !!freshCartItem,
                    hasVariant: !!freshCartItem?.variant,
                    hasAllocations: !!freshCartItem?.variant?.selling_plan_allocations
                  });
        }
              } catch (freshCartError) {
                console.warn('SubscriptionSelector: DEBUG - Failed to fetch fresh cart data', {
                  productId: currentItem.product_id,
                  error: freshCartError.message
                });
              }
            }
            
            // If still no plan found, use original plan as final fallback
            if (!planIdToUse) {
          console.warn('SubscriptionSelector: No product-specific plan ID found, using original plan as fallback', {
            productId: currentItem.product_id,
            productTitle: currentItem.title,
            planName: planName,
            originalPlanId: sellingPlan,
                hasMapping: !!productPlanMap[currentItem.product_id],
                hasCartAllocations: !!currentItem.variant?.selling_plan_allocations
          });
          planIdToUse = sellingPlan;
            }
          }
        } else {
          // No plan name provided, use the original plan ID (for non-Recharge scenarios)
          planIdToUse = sellingPlan || null;
        }
        
        const itemUpdateStart = performance.now();
        
        console.log('SubscriptionSelector: updating bundle item ' + (index + 1) + '/' + bundleItems.length, {
          itemKey: currentItem.key,
          originalKey: originalItem.key,
          itemTitle: currentItem.title,
          variantId: currentItem.variant_id,
          productId: currentItem.product_id,
          lineIndex: lineIndex,
          currentSellingPlan: currentItem.selling_plan_allocation?.selling_plan?.id,
          newSellingPlan: planIdToUse,
          planName: planName,
          existingProperties: currentItem.properties
        });
        
        try {
          const result = await this.changeCartItem(
            currentItem.key,
            currentItem.quantity,
            planIdToUse || null,
            isLast,
            lineIndex,  // 1-based line index required for selling_plan updates
            currentItem.properties  // Preserve existing properties including bundle info
          );
          
          // ALWAYS fetch updated cart data after each update attempt (success or failure)
          // This is critical because cart item keys and line indices change after each update
          // Even if one update fails, previous successful updates may have changed the cart
          // Add a small delay to ensure server has processed the update before fetching cart
          await new Promise(resolve => setTimeout(resolve, 50));
          
          try {
            if (result && result.success && result.data && result.data.items) {
              // Use response data if available (most efficient)
              currentCartData = result.data;
              console.log('SubscriptionSelector: Cart updated, using response data for next item', {
                newItemCount: currentCartData.items.length,
                bundleItemsInCart: currentCartData.items.filter(item => 
                  item.properties && 
                  item.properties['_bundle'] === 'true' && 
                  item.properties['_bundle_id'] === bundleId
                ).length
              });
            } else {
              // Always fetch fresh cart data to ensure we have latest state
              // This is necessary because:
              // 1. Failed updates might still have changed cart state (partial updates)
              // 2. Previous successful updates definitely changed cart state
              // 3. We need accurate line indices for subsequent items
              const updatedCartResponse = await fetch('/cart.js');
              const updatedCartData = await updatedCartResponse.json();
              if (!updatedCartData.status && updatedCartData.items) {
                currentCartData = updatedCartData;
                console.log('SubscriptionSelector: Fetched fresh cart data after update attempt', {
                  newItemCount: currentCartData.items.length,
                  updateSuccess: result && result.success,
                  updateError: result && result.error
                });
              } else {
                console.warn('SubscriptionSelector: Failed to get valid cart data', updatedCartData);
              }
            }
          } catch (fetchError) {
            console.warn('SubscriptionSelector: Failed to fetch updated cart, continuing with previous data', fetchError);
            // If we can't fetch cart, we should probably stop to avoid cascading errors
            // But for now, continue with previous data and hope for the best
          }
          
          // Check if selling plan is not supported for this variant
          if (result && result.error && result.errorMessage && 
              result.errorMessage.includes('Cannot apply selling plan')) {
            console.warn('SubscriptionSelector: Selling plan not supported for variant, skipping', {
              itemKey: currentItem.key,
              itemTitle: currentItem.title,
              sellingPlan: sellingPlan
            });
            // Mark as skipped but not a critical error
            results.push({ skipped: true, item: originalItem, reason: 'Selling plan not supported for this variant' });
          } else {
            results.push(result);
          }
          
          // Track item update time
          const itemUpdateTime = performance.now() - itemUpdateStart;
          performanceTiming.itemUpdateTimes.push({
            index: index + 1,
            itemTitle: currentItem.title,
            time: itemUpdateTime
          });
          console.log('SubscriptionSelector: ⏱️ Item ' + (index + 1) + ' update took', itemUpdateTime.toFixed(2), 'ms');
          
          // Add minimal delay between requests to avoid rate limiting (except for last item)
          // OPTIMIZATION: Reduced from 100ms to 100ms for safer updates to prevent 429 errors
          if (!isLast) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        } catch (error) {
          console.warn('SubscriptionSelector: Failed to update bundle item', {
            itemKey: currentItem.key,
            itemTitle: currentItem.title,
            error: error
          });
          results.push({ error: true, item: originalItem, errorMessage: error.message || 'Unknown error' });
        }
      }
      
      // Analyze results - separate actual errors from skipped items
      const successful = results.filter(r => r && r.success);
      const skipped = results.filter(r => r && r.skipped);
      const failed = results.filter(r => r && r.error && !r.skipped);
      
      // Track item update phase timing
      performanceTiming.steps.itemUpdatePhase = performance.now() - itemUpdatePhaseStart;
      console.log('SubscriptionSelector: ⏱️ Item update phase took', performanceTiming.steps.itemUpdatePhase.toFixed(2), 'ms');
      
      // Calculate total time
      performanceTiming.totalTime = performance.now() - performanceTiming.startTime;
      
      console.log('SubscriptionSelector: ========== BUNDLE UPDATE FINAL SUMMARY ==========');
      console.log('SubscriptionSelector: Overall Results', {
        totalItems: bundleItems.length,
        successful: successful.length,
        skipped: skipped.length,
        failed: failed.length,
        successRate: `${Math.round((successful.length / bundleItems.length) * 100)}%`
      });
      
      // Log performance timing summary
      console.log('SubscriptionSelector: ========== PERFORMANCE TIMING SUMMARY ==========');
      console.log('SubscriptionSelector: ⏱️ Total Execution Time:', performanceTiming.totalTime.toFixed(2), 'ms', '(', (performanceTiming.totalTime / 1000).toFixed(2), 'seconds)');
      console.log('SubscriptionSelector: ⏱️ Breakdown:', {
        'Initial Cart Fetch': performanceTiming.steps.initialCartFetch ? performanceTiming.steps.initialCartFetch.toFixed(2) + ' ms' : 'N/A',
        'Product Data Fetching': performanceTiming.steps.productDataFetching ? performanceTiming.steps.productDataFetching.toFixed(2) + ' ms' : 'N/A',
        'Item Update Phase': performanceTiming.steps.itemUpdatePhase ? performanceTiming.steps.itemUpdatePhase.toFixed(2) + ' ms' : 'N/A',
        'Average Item Update': performanceTiming.itemUpdateTimes.length > 0 
          ? (performanceTiming.itemUpdateTimes.reduce((sum, item) => sum + item.time, 0) / performanceTiming.itemUpdateTimes.length).toFixed(2) + ' ms'
          : 'N/A'
      });
      if (performanceTiming.itemUpdateTimes.length > 0) {
        console.log('SubscriptionSelector: ⏱️ Individual Item Update Times:', performanceTiming.itemUpdateTimes.map(item => 
          `Item ${item.index} (${item.itemTitle}): ${item.time.toFixed(2)} ms`
        ));
      }
      console.log('SubscriptionSelector: ========== END PERFORMANCE TIMING ==========');
      console.log('SubscriptionSelector: Detailed Item Results', results.map((r, i) => ({
        index: i + 1,
        productTitle: bundleItems[i]?.title || 'Unknown',
        productId: bundleItems[i]?.product_id,
        variantId: bundleItems[i]?.variant_id,
        success: r && r.success,
        skipped: r && r.skipped,
        error: r?.errorMessage || r?.reason || 'None'
      })));
      if (skipped.length > 0) {
        console.error('SubscriptionSelector: ⚠️ SKIPPED PRODUCTS (No Plan ID Found):', results
          .map((r, i) => ({ result: r, index: i, item: bundleItems[i] }))
          .filter(({ result }) => result && result.skipped)
          .map(({ item, result }) => ({
            productTitle: item?.title || 'Unknown',
            productId: item?.product_id,
            variantId: item?.variant_id,
            reason: result.reason || 'No product-specific plan ID found'
          })));
      }
      console.log('SubscriptionSelector: ========== END BUNDLE UPDATE SUMMARY ==========');

      // Show appropriate messages based on results
      const actuallyUpdated = successful.length;
      const notSupported = skipped.length;
      const errors = failed.length;
      
      if (actuallyUpdated === 0 && (notSupported > 0 || errors > 0)) {
        // None succeeded
        if (notSupported === bundleItems.length) {
          this.showError('This subscription plan is not available for the items in your bundle.');
        } else {
          this.showError('Failed to update bundle subscription. Please try again.');
        }
      } else if (notSupported > 0 || errors > 0) {
        // Partial success
        console.warn('SubscriptionSelector: Partial bundle update', {
          updated: actuallyUpdated,
          notSupported: notSupported,
          errors: errors
        });
        this.showSuccess('Subscription updated for ' + actuallyUpdated + ' of ' + bundleItems.length + ' items.');
        // Collapse view after partial success - wait for cart to re-render
        this.scheduleCollapseAfterRender();
      } else if (actuallyUpdated > 0) {
        // All succeeded
        console.log('SubscriptionSelector: All bundle items updated successfully');
        this.showSuccess('Bundle subscription updated successfully!');
        // Collapse view after success - wait for cart to re-render
        this.scheduleCollapseAfterRender();
      }

      // Verify bundle integrity after all updates
      if (actuallyUpdated > 0) {
        try {
          const verifyCartResponse = await fetch('/cart.js');
          const verifyCartData = await verifyCartResponse.json();
          
          if (!verifyCartData.status && verifyCartData.items) {
            const remainingBundleItems = verifyCartData.items.filter(item =>
              item.properties &&
              item.properties['_bundle'] === 'true' &&
              item.properties['_bundle_id'] === bundleId
            );
            
            console.log('SubscriptionSelector: bundle integrity check', {
              bundleId: bundleId,
              expectedItems: bundleItems.length,
              remainingBundleItems: remainingBundleItems.length,
              allItems: verifyCartData.items.length,
              bundleItemsFound: remainingBundleItems.map(item => ({
                key: item.key,
                title: item.title,
                hasProperties: !!item.properties,
                bundleId: item.properties?.['_bundle_id']
              }))
            });
            
            if (remainingBundleItems.length !== bundleItems.length) {
              console.error('SubscriptionSelector: Bundle integrity compromised!', {
                expected: bundleItems.length,
                found: remainingBundleItems.length,
                missingItems: bundleItems.length - remainingBundleItems.length
              });
            }
          }
        } catch (verifyError) {
          console.warn('SubscriptionSelector: Failed to verify bundle integrity', verifyError);
        }
      }
      
      // Remove loading overlay and re-enable UI
      if (loadingOverlay && loadingOverlay.parentNode) {
        loadingOverlay.remove();
      }
      
      if (subscriptionSelector) {
        // Re-enable radio buttons
        const radioButtons = subscriptionSelector.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(radio => {
          radio.disabled = false;
          radio.style.pointerEvents = '';
        });
      }
      
      // Clear the bundle update flag
      this._isUpdatingBundle = false;
      
      // Always update the UI to reflect the selected subscription (even if some items failed)
      // This ensures the radio button shows what the user selected
      // Wait a bit for cart to finish rendering before updating UI
      console.log('SubscriptionSelector: scheduling UI update for selected subscription', sellingPlan);
      
      // Store the selling plan to update after cart renders
      const updateUI = () => {
        console.log('SubscriptionSelector: updating UI after cart render', sellingPlan);
        // Only update if we're not in the middle of a bundle update
        if (!this._isUpdatingBundle) {
        this.updateSelectedRadioButton(sellingPlan);
        }
      };
      
      // Wait longer for cart to fully render before updating UI
      setTimeout(updateUI, 300);
      
      // Also listen for cart render completion (but only once at the end)
      const cartRenderHandler = () => {
        console.log('SubscriptionSelector: cart render event received, updating UI');
        // Only update if we're not in the middle of a bundle update
        if (!this._isUpdatingBundle) {
        updateUI();
        }
        document.removeEventListener('ajaxProduct:added', cartRenderHandler);
      };
      document.addEventListener('ajaxProduct:added', cartRenderHandler);

    } catch (error) {
      // Calculate total time even on error
      performanceTiming.totalTime = performance.now() - performanceTiming.startTime;
      console.error('SubscriptionSelector: Error changing bundle subscription:', error);
      console.error('SubscriptionSelector: ⏱️ Execution failed after', performanceTiming.totalTime.toFixed(2), 'ms', '(', (performanceTiming.totalTime / 1000).toFixed(2), 'seconds)');

      // Hide loader on error
      this.hideLoader();

      // Remove loading overlay on error
      if (loadingOverlay && loadingOverlay.parentNode) {
        loadingOverlay.remove();
      }

      if (subscriptionSelector) {
        // Re-enable radio buttons on error
        const radioButtons = subscriptionSelector.querySelectorAll('input[type="radio"]');
        radioButtons.forEach(radio => {
          radio.disabled = false;
          radio.style.pointerEvents = '';
        });
      }

      // Clear the bundle update flag
      this._isUpdatingBundle = false;

      this.showError('Failed to update bundle subscription. Please try again.');
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
    } finally {
      // Loading state will be removed by showSuccess/showError toasts
      // Add a safety timeout to remove loading if toast doesn't appear (edge case)
      if (checkoutButton) {
        setTimeout(() => {
          if (checkoutButton.classList.contains('loading')) {
            console.warn('SubscriptionSelector: Loading state still active after timeout, removing as safety measure');
            checkoutButton.setAttribute('aria-disabled', false);
            checkoutButton.classList.remove('loading');
            if (checkoutButton.dataset.originalHTML) {
              checkoutButton.innerHTML = checkoutButton.dataset.originalHTML;
            }
          }
        }, 6000); // 6 seconds safety timeout
      }
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

      // Hide loader after success/error
      setTimeout(() => {
        this.hideLoader();
      }, 500);
    }
  }

  async changeCartItem(key, quantity, selling_plan, isLastAction = true, lineIndex = null, existingProperties = null) {
    console.log('SubscriptionSelector: changeCartItem called', {
      key: key,
      quantity: quantity,
      selling_plan: selling_plan,
      selling_plan_type: typeof selling_plan,
      isLastAction: isLastAction,
      lineIndex: lineIndex,
      hasProperties: !!existingProperties
    });

    // Show loader for individual subscription changes
    if (!this.isBundleMode) {
      this.showLoader();
    }

    // Validate key or line index
    if ((!key || key === '' || key === 'undefined') && !lineIndex) {
      const errorMsg = 'Invalid item key. The cart may have been updated.';
      console.error('SubscriptionSelector: Invalid item key', key);
      if (isLastAction) {
        this.showError(errorMsg);
        if (!this.isBundleMode) {
          this.hideLoader();
        }
      }
      return Promise.resolve({ error: true, errorMessage: errorMsg });
    }

    const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
    const miniCart = document.querySelector('mini-cart');
    const cartForm = document.querySelector('form.mini-cart');
    
    if (checkoutButton && isLastAction) {
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
    }
    
    // Convert empty string to null for one-time purchase
    const sellingPlanValue = selling_plan === '' || selling_plan === null ? null : selling_plan;

    console.log('SubscriptionSelector: sellingPlanValue after conversion', sellingPlanValue);

    // CRITICAL: Shopify Cart API requires using 'line' (1-based index) instead of 'id' when updating selling_plan
    // See: https://shopify.dev/docs/api/ajax/reference/cart#post--locale-cart-changejs
    // "When specifying the selling_plan property... You can use only the line property for identifying the line item."
    // This means: if we're updating selling_plan (even if setting to null), we MUST use 'line', NEVER 'id'
    const requestData = {
      quantity: quantity,
      selling_plan: sellingPlanValue,
      // IMPORTANT: Shopify expects "sections" to be section identifiers (like 'mini-cart'),
      // not DOM element ids. Our MiniCart.getSectionsToRender() returns {id, section, selector}
      // so we must send section.section here.
      sections: miniCart && typeof miniCart.getSectionsToRender === 'function'
        ? miniCart.getSectionsToRender().map((section) => section.section).filter(Boolean)
        : [],
      sections_url: window.location.pathname
    };
    
    // Since we're always including selling_plan in the request (even if null to remove it),
    // we MUST use 'line' parameter per Shopify API requirements
    // If lineIndex is not provided, we need to fetch the cart and find it
    let finalLineIndex = lineIndex;
    
    if (!finalLineIndex || finalLineIndex <= 0) {
      // For bundle updates, lineIndex should always be provided
      // For individual item updates, we need to calculate it from the cart
      if (this.isBundleMode) {
        const errorMsg = 'Line index required for bundle selling plan update. The cart may have been updated.';
        console.error('SubscriptionSelector: Missing lineIndex for bundle selling_plan update', { 
          key, 
          selling_plan, 
          lineIndex,
          bundleId: this.bundleId
        });
        if (isLastAction) {
          this.showError(errorMsg);
        }
        return Promise.resolve({ error: true, errorMessage: errorMsg });
      }
      
      // For individual items, fetch cart and find line index
      console.log('SubscriptionSelector: Calculating lineIndex from cart for individual item', { key });
      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        if (cartData.status) {
          throw new Error('Failed to get cart');
        }
        const itemIndex = cartData.items.findIndex(item => item.key === key);
        if (itemIndex === -1) {
          const errorMsg = 'Item not found in cart. The cart may have been updated.';
          console.error('SubscriptionSelector: Item not found in cart', { key });
          if (isLastAction) {
            this.showError(errorMsg);
          }
          return Promise.resolve({ error: true, errorMessage: errorMsg });
        }
        finalLineIndex = itemIndex + 1; // Convert to 1-based index
        console.log('SubscriptionSelector: Calculated lineIndex from cart', { key, finalLineIndex });
      } catch (error) {
        const errorMsg = 'Failed to get cart data. Please try again.';
        console.error('SubscriptionSelector: Error fetching cart to calculate lineIndex', error);
        if (isLastAction) {
          this.showError(errorMsg);
        }
        return Promise.resolve({ error: true, errorMessage: errorMsg });
      }
    }
    
    requestData.line = finalLineIndex;
    // Include existing properties to preserve bundle info
    if (existingProperties) {
      requestData.properties = existingProperties;
    }

    console.log('SubscriptionSelector: sending request to /cart/change.js', requestData);

    let formData = JSON.stringify(requestData);

    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData
    })
    .then(response => {
      console.log('SubscriptionSelector: response status', response.status);
       return response.json();
    })
    .then(data=>{
      console.log('SubscriptionSelector: response data', data);

      if(!data.status){
        // Verify bundle properties are preserved after update
        if (this.isBundleMode && this.bundleId && data.items) {
          // Find updated item by line index (if available) or by key
          // Use finalLineIndex since that's what was actually used in the request
          let updatedItem;
          if (finalLineIndex && finalLineIndex > 0 && data.items[finalLineIndex - 1]) {
            // finalLineIndex is 1-based, array is 0-based
            updatedItem = data.items[finalLineIndex - 1];
          } else {
            // Fallback: try to find by key (key might have changed after update)
            updatedItem = data.items.find(item => item.key === key);
            // If still not found, try matching by variant_id and bundle_id
            if (!updatedItem && existingProperties) {
              updatedItem = data.items.find(item => 
                item.variant_id && 
                item.properties && 
                item.properties['_bundle'] === 'true' && 
                item.properties['_bundle_id'] === this.bundleId
              );
            }
          }
          
          if (updatedItem) {
            const hasBundleProperty = updatedItem.properties && 
              updatedItem.properties['_bundle'] === 'true' && 
              updatedItem.properties['_bundle_id'] === this.bundleId;
            
            if (!hasBundleProperty) {
              console.error('SubscriptionSelector: Bundle properties lost after update!', {
                finalLineIndex: finalLineIndex,
                originalLineIndex: lineIndex,
                itemKey: key,
                bundleId: this.bundleId,
                itemProperties: updatedItem.properties,
                passedProperties: existingProperties,
                allItems: data.items.map(item => ({
                  key: item.key,
                  variant_id: item.variant_id,
                  properties: item.properties
                }))
              });
            } else {
              console.log('SubscriptionSelector: Bundle properties preserved', {
                finalLineIndex: finalLineIndex,
                originalLineIndex: lineIndex,
                itemKey: key,
                bundleId: this.bundleId,
                hasBundle: hasBundleProperty
              });
            }
          } else {
            console.warn('SubscriptionSelector: Could not find updated item to verify bundle properties', {
              finalLineIndex: finalLineIndex,
              originalLineIndex: lineIndex,
              itemKey: key,
              bundleId: this.bundleId,
              totalItems: data.items.length
            });
          }
        }
        
        console.log('SubscriptionSelector: cart change successful, updating UI');
        if(!miniCart || typeof miniCart.renderContents !== 'function') {
          console.warn('SubscriptionSelector: Mini-cart element not found, redirecting to cart page');
          window.location = theme.routes.cart_url;
          return { success: true, data: data };
        }else{
          // For bundle updates, only render cart UI for the last item to prevent flickering
          // For individual item updates, always render
          if (this.isBundleMode && !isLastAction) {
            console.log('SubscriptionSelector: Bundle update in progress, skipping cart UI render to prevent flickering');
            // Still update cart data internally but don't trigger UI re-render
            // The cart data is already updated via the API response
          } else {
            // Re-render mini-cart sections using Shopify's native sections response
            try {
              miniCart.renderContents(data);
            } catch (e) {
              console.error('SubscriptionSelector: Failed to render mini-cart sections', e);
            }
        }
        }
        
        // Only dispatch cart update event for the last action to prevent multiple UI updates
        if (isLastAction) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
        }

        // For individual item changes, update the UI radio button selection and show success toast
        if (!this.isBundleMode && isLastAction) {
          // Show success toast for individual item updates
          const successMessage = selling_plan ? 'Subscription updated successfully!' : 'Switched to one-time purchase.';
          this.showSuccess(successMessage);
          
          console.log('SubscriptionSelector: scheduling individual item UI update for selling plan', selling_plan);
          // Wait for cart to render before updating UI
          setTimeout(() => {
            console.log('SubscriptionSelector: updating individual item UI after delay', selling_plan);
            this.updateSelectedRadioButton(selling_plan);
            this.updateCollapsedView();
            // Collapse view after update
            this.collapseView();
          }, 200);
          
          // Also listen for cart render completion
          const cartRenderHandler = () => {
            console.log('SubscriptionSelector: cart render event received for individual item, updating UI');
            this.updateSelectedRadioButton(selling_plan);
            this.updateCollapsedView();
            // Collapse view after cart renders
            this.collapseView();
            document.removeEventListener('ajaxProduct:added', cartRenderHandler);
          };
          document.addEventListener('ajaxProduct:added', cartRenderHandler);
        }
        return { success: true, data: data };
      } else {
        console.error('SubscriptionSelector: Cart change failed with error status', data);
        let errorMessage = data.description || data.message || 'Failed to update subscription';
        
        // Provide user-friendly message for common errors
        if (errorMessage.includes('no valid id or line parameter') || 
            errorMessage.includes('no valid id') ||
            data.status === 'bad_request') {
          errorMessage = 'The cart was updated. Please try selecting your subscription again.';
        }
        
        if (isLastAction) {
          this.showError(errorMessage);
        }
        return { 
          error: true, 
          errorMessage: errorMessage,
          data: data 
        };
      }
    })
    .catch((error) => {
      console.error('SubscriptionSelector: Error in changeCartItem:', error);
      const errorMessage = error.message || 'Network error. Please check your connection and try again.';
      if (isLastAction) {
        this.showError(errorMessage);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
      }
      // Return error object instead of throwing for bundle updates
      return { 
        error: true, 
        errorMessage: errorMessage,
        originalError: error 
      };
    })
    .finally(() => {
      // Hide loader for individual subscription changes
      if (!this.isBundleMode) {
        setTimeout(() => {
          this.hideLoader();
        }, 500);
      }

      // Only remove loading for individual item updates (not bundle updates)
      // Bundle updates will remove loading after showing the toast
      // Individual item updates will have loading removed by the toast handler
      if (checkoutButton && isLastAction && !this.isBundleMode) {
        // For individual items, loading will be removed by showSuccess/showError
        // But if there's an error that doesn't call showError, remove it here
        // (This is a safety fallback)
        setTimeout(() => {
          if (checkoutButton.classList.contains('loading')) {
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
            if (checkoutButton.dataset.originalHTML) {
              checkoutButton.innerHTML = checkoutButton.dataset.originalHTML;
            }
          }
        }, 100);
      }
      if (cartForm && cartForm.classList.contains('is-empty')) cartForm.classList.remove('is-empty');
    }); 
  }

  updateSelectedRadioButton(sellingPlan) {
    // Prevent recursive calls
    if (this._isUpdatingUI) {
      console.log('SubscriptionSelector: Already updating UI, skipping');
      return;
    }
    
    // Prevent UI updates during bundle subscription changes to avoid flickering
    if (this._isUpdatingBundle) {
      console.log('SubscriptionSelector: Bundle update in progress, skipping UI update to prevent flickering');
      return;
    }

    console.log('SubscriptionSelector: updateSelectedRadioButton called with', {
      sellingPlan: sellingPlan,
      sellingPlanType: typeof sellingPlan,
      isBundleMode: this.isBundleMode,
      bundleId: this.bundleId,
      selectorExists: !!this,
      selectorInDOM: document.contains(this)
    });

    // Check if selector still exists in DOM (might have been re-rendered by cart update)
    if (!document.contains(this)) {
      console.warn('SubscriptionSelector: Component no longer in DOM, will retry after cart render');
      // Wait a bit for cart to finish rendering, then try to find the selector again
      setTimeout(() => {
        const bundleId = this.bundleId;
        const itemKey = this.itemKey;
        let selector = null;
        
        if (this.isBundleMode && bundleId) {
          // Find bundle selector by bundle ID
          const selectors = document.querySelectorAll('subscription-selector[data-bundle-id="' + bundleId + '"]');
          selector = selectors[selectors.length - 1]; // Get the most recent one
        } else if (itemKey) {
          // Find individual item selector by item key (try partial match since keys change)
          const selectors = document.querySelectorAll('subscription-selector[data-item-key]');
          selector = Array.from(selectors).find(s => {
            const key = s.dataset.itemKey;
            return key && itemKey && key.split(':')[0] === itemKey.split(':')[0];
          });
        }
        
        if (selector && selector.updateSelectedRadioButton) {
          console.log('SubscriptionSelector: Found re-rendered selector, updating UI');
          selector.updateSelectedRadioButton(sellingPlan);
        } else {
          console.warn('SubscriptionSelector: Could not find re-rendered selector');
        }
      }, 500);
      return;
    }

    // Set flag to prevent recursive calls
    this._isUpdatingUI = true;

    try {
      // Find all radio buttons in this subscription selector
      const radioButtons = this.querySelectorAll('input[type="radio"]');
      console.log('SubscriptionSelector: found radio buttons for UI update', {
        count: radioButtons.length,
        radioValues: Array.from(radioButtons).map(r => r.value),
        currentChecked: Array.from(radioButtons).find(r => r.checked)?.value
      });

      if (radioButtons.length === 0) {
        console.warn('SubscriptionSelector: No radio buttons found in component');
        return;
      }

      // Determine which value to check for (handle empty string for one-time purchase)
      const targetValue = sellingPlan === null || sellingPlan === undefined || sellingPlan === '' ? '' : sellingPlan.toString();
      console.log('SubscriptionSelector: target value for radio selection', {
        targetValue: targetValue,
        originalSellingPlan: sellingPlan
      });

      let foundSelected = false;
      radioButtons.forEach((radio, index) => {
        const shouldBeChecked = radio.value === targetValue;
        const wasChecked = radio.checked;
        
        console.log('SubscriptionSelector: radio ' + index, {
          value: radio.value,
          name: radio.name,
          shouldBeChecked: shouldBeChecked,
          wasChecked: wasChecked,
          willChange: shouldBeChecked !== wasChecked
        });

        if (shouldBeChecked) {
          radio.checked = true;
          foundSelected = true;
          console.log('SubscriptionSelector: radio button selected', {
            index: index,
            value: radio.value,
            changed: !wasChecked
          });
          // DO NOT dispatch change event here - it causes infinite loops
        } else {
          radio.checked = false;
        }
      });

      if (!foundSelected) {
        console.warn('SubscriptionSelector: No radio button found for selling plan', {
          sellingPlan: sellingPlan,
          targetValue: targetValue,
          availableValues: Array.from(radioButtons).map(r => r.value)
        });
      } else {
        console.log('SubscriptionSelector: Successfully updated radio button selection', {
          selectedValue: targetValue,
          selectedRadio: this.querySelector('input[type="radio"]:checked')?.value
        });
      }

      // Dispatch a custom event (not the native change event) to notify listeners
      const checkedRadio = this.querySelector('input[type="radio"]:checked');
      const labelText = checkedRadio?.closest('label')?.querySelector('.radio-label')?.textContent || 
                        checkedRadio?.closest('label')?.textContent?.trim() || 
                        'Unknown';
      
      this.dispatchEvent(new CustomEvent('subscription-updated', {
        detail: { 
          value: sellingPlan, 
          label: labelText,
          radioValue: checkedRadio?.value
        }
      }));

      console.log('SubscriptionSelector: UI update completed', {
        selectedRadio: checkedRadio?.value,
        selectedLabel: labelText
      });

      // Update collapsed view to reflect the new selection
      this.updateCollapsedView();
    } finally {
      // Reset flag after a short delay to allow any pending operations to complete
      setTimeout(() => {
        this._isUpdatingUI = false;
      }, 100);
    }
  }

  showSuccess(message) {
    console.log('SubscriptionSelector Success:', message);

    // Try to show success message as toast in cart drawer
    const cart = document.querySelector('form.mini-cart');
    if (cart) {
      // Remove any existing error/success containers first
      const existingError = cart.querySelector('.subscription-toast-error');
      const existingSuccess = cart.querySelector('.subscription-toast-success');
      if (existingError) existingError.remove();
      if (existingSuccess) existingSuccess.remove();

      // Create toast-style success container - positioned on RIGHT side
      const successContainer = document.createElement('div');
      successContainer.className = 'subscription-toast-success';
      successContainer.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000; ' +
        'background: #10b981; color: white; padding: 16px 20px; border-radius: 8px; ' +
        'box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 14px; font-weight: 500; ' +
        'min-width: 280px; max-width: 400px; animation: slideInRight 0.3s ease-out; ' +
        'word-wrap: break-word;';
      successContainer.innerHTML = '<span style="margin-right: 8px; font-size: 16px;">✓</span>' + message;

      // Add animation keyframes if not already present
      if (!document.getElementById('subscription-toast-styles')) {
        const style = document.createElement('style');
        style.id = 'subscription-toast-styles';
        style.textContent = '@keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } } ' +
          '@keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }';
        document.head.appendChild(style);
      }

      // Insert into body for fixed positioning
      document.body.appendChild(successContainer);

      // Remove loading state from checkout button after toast appears
      const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
      if (checkoutButton) {
        setTimeout(() => {
          checkoutButton.setAttribute('aria-disabled', false);
          checkoutButton.classList.remove('loading');
          if (checkoutButton.dataset.originalHTML) {
            checkoutButton.innerHTML = checkoutButton.dataset.originalHTML;
          }
        }, 100);
      }

      // Auto-hide after 4 seconds with fade out animation
      setTimeout(() => {
        if (successContainer && successContainer.parentNode) {
          successContainer.style.animation = 'slideOutRight 0.3s ease-out';
          setTimeout(() => {
            if (successContainer && successContainer.parentNode) {
              successContainer.parentNode.removeChild(successContainer);
            }
          }, 300);
        }
      }, 4000);
    } else {
      // Fallback: show alert if cart drawer not available
      alert(message);
    }
  }

  showError(message) {
    console.error('SubscriptionSelector Error:', message);

    // Try to show error as toast in cart drawer
    const cart = document.querySelector('form.mini-cart');
    if (cart) {
      // Remove any existing error/success containers first
      const existingError = cart.querySelector('.subscription-toast-error');
      const existingSuccess = cart.querySelector('.subscription-toast-success');
      if (existingError) existingError.remove();
      if (existingSuccess) existingSuccess.remove();

      // Create toast-style error container - positioned on RIGHT side
      const errorContainer = document.createElement('div');
      errorContainer.className = 'subscription-toast-error';
      errorContainer.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000; ' +
        'background: #ef4444; color: white; padding: 16px 20px; border-radius: 8px; ' +
        'box-shadow: 0 4px 12px rgba(0,0,0,0.15); font-size: 14px; font-weight: 500; ' +
        'min-width: 280px; max-width: 400px; animation: slideInRight 0.3s ease-out; ' +
        'word-wrap: break-word;';
      errorContainer.innerHTML = '<span style="margin-right: 8px; font-size: 16px;">✕</span>' + message;

      // Add animation keyframes if not already present
      if (!document.getElementById('subscription-toast-styles')) {
        const style = document.createElement('style');
        style.id = 'subscription-toast-styles';
        style.textContent = '@keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } } ' +
          '@keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }';
        document.head.appendChild(style);
      }

      // Insert into body for fixed positioning
      document.body.appendChild(errorContainer);

      // Remove loading state from checkout button after toast appears
      const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
      if (checkoutButton) {
        setTimeout(() => {
          checkoutButton.setAttribute('aria-disabled', false);
          checkoutButton.classList.remove('loading');
          if (checkoutButton.dataset.originalHTML) {
            checkoutButton.innerHTML = checkoutButton.dataset.originalHTML;
          }
        }, 100);
      }

      // Auto-hide after 5 seconds with fade out animation
      setTimeout(() => {
        if (errorContainer && errorContainer.parentNode) {
          errorContainer.style.animation = 'slideOutRight 0.3s ease-out';
          setTimeout(() => {
            if (errorContainer && errorContainer.parentNode) {
              errorContainer.parentNode.removeChild(errorContainer);
            }
          }, 300);
        }
      }, 5000);
    } else {
      // Fallback: only show alert if cart drawer not available
      console.warn('SubscriptionSelector: Cart drawer not found, showing alert as fallback');
      alert(message);
    }
  }

}

customElements.define('subscription-selector', SubscriptionSelector);



class lineItemSubscription extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.selectItem = this.querySelector('select');  
    if(!this.selectItem) return;
    this.selectItem.addEventListener('change',()=>{
      this.changeCartItem(this.selectItem.options[this.selectItem.selectedIndex].dataset.itemKey,this.selectItem.options[this.selectItem.selectedIndex].dataset.itemQuantity,this.selectItem.value);
    })
  }

  changeCartItem(key, quantity, selling_plan) {
    const checkoutButton = document.querySelector('mini-cart button[name="checkout"]');
    const cart = document.querySelector('form.mini-cart');
    
    if(checkoutButton){
      checkoutButton.setAttribute('aria-disabled', true);
      checkoutButton.classList.add('loading');
    }
    
    let formData = JSON.stringify({
      id: key,
      quantity: quantity,
      selling_plan: selling_plan,
      // Request updated sections so mini-cart prices/totals refresh after subscription change
      sections: document.querySelector('mini-cart')?.getSectionsToRender?.().map((s) => s.section).filter(Boolean) || [],
      sections_url: window.location.pathname
    });
    
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: formData
    })
    .then(response => {
       return response.json();
    })
    .then(data=>{
      if(!data.status){
        if(!cart) {
          window.location = theme.routes.cart_url;
          return;
        }else{
          // Cart will update automatically through Shopify's mechanisms
          // No need to manually call renderContents
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data
          }
        }));
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error'));
    })
    .finally(() => {
      if(checkoutButton){
        checkoutButton.setAttribute('aria-disabled', false);
        checkoutButton.classList.remove('loading');
      }
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    }); 
  }
}
customElements.define("line-item-subscription", lineItemSubscription);
